/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { i as iconPropTypes, _ as _objectWithoutProperties, I as Icon, a as _objectSpread2 } from '../iconPropTypes-201665c4.js';
import React from 'react';
import '@carbon/icon-helpers';
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _circle, _circle2, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _circle3, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _circle4, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _rect, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _switch, _switch2, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _circle5, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _circle6, _circle7, _path191, _path192, _circle8, _path193, _path194, _path195, _path196, _circle9, _circle10, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _circle11, _path234, _circle12, _path235, _path236, _circle13, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258;
var _excluded = ["children", "size"],
  _excluded2 = ["children", "size"],
  _excluded3 = ["children", "size"],
  _excluded4 = ["children", "size"],
  _excluded5 = ["children", "size"],
  _excluded6 = ["children", "size"],
  _excluded7 = ["children", "size"],
  _excluded8 = ["children", "size"],
  _excluded9 = ["children", "size"],
  _excluded10 = ["children", "size"],
  _excluded11 = ["children", "size"],
  _excluded12 = ["children", "size"],
  _excluded13 = ["children", "size"],
  _excluded14 = ["children", "size"],
  _excluded15 = ["children", "size"],
  _excluded16 = ["children", "size"],
  _excluded17 = ["children", "size"],
  _excluded18 = ["children", "size"],
  _excluded19 = ["children", "size"],
  _excluded20 = ["children", "size"],
  _excluded21 = ["children", "size"],
  _excluded22 = ["children", "size"],
  _excluded23 = ["children", "size"],
  _excluded24 = ["children", "size"],
  _excluded25 = ["children", "size"],
  _excluded26 = ["children", "size"],
  _excluded27 = ["children", "size"],
  _excluded28 = ["children", "size"],
  _excluded29 = ["children", "size"],
  _excluded30 = ["children", "size"],
  _excluded31 = ["children", "size"],
  _excluded32 = ["children", "size"],
  _excluded33 = ["children", "size"],
  _excluded34 = ["children", "size"],
  _excluded35 = ["children", "size"],
  _excluded36 = ["children", "size"],
  _excluded37 = ["children", "size"],
  _excluded38 = ["children", "size"],
  _excluded39 = ["children", "size"],
  _excluded40 = ["children", "size"],
  _excluded41 = ["children", "size"],
  _excluded42 = ["children", "size"],
  _excluded43 = ["children", "size"],
  _excluded44 = ["children", "size"],
  _excluded45 = ["children", "size"],
  _excluded46 = ["children", "size"],
  _excluded47 = ["children", "size"],
  _excluded48 = ["children", "size"],
  _excluded49 = ["children", "size"],
  _excluded50 = ["children", "size"],
  _excluded51 = ["children", "size"],
  _excluded52 = ["children", "size"],
  _excluded53 = ["children", "size"],
  _excluded54 = ["children", "size"],
  _excluded55 = ["children", "size"],
  _excluded56 = ["children", "size"],
  _excluded57 = ["children", "size"],
  _excluded58 = ["children", "size"],
  _excluded59 = ["children", "size"],
  _excluded60 = ["children", "size"],
  _excluded61 = ["children", "size"],
  _excluded62 = ["children", "size"],
  _excluded63 = ["children", "size"],
  _excluded64 = ["children", "size"],
  _excluded65 = ["children", "size"],
  _excluded66 = ["children", "size"],
  _excluded67 = ["children", "size"],
  _excluded68 = ["children", "size"],
  _excluded69 = ["children", "size"],
  _excluded70 = ["children", "size"],
  _excluded71 = ["children", "size"],
  _excluded72 = ["children", "size"],
  _excluded73 = ["children", "size"],
  _excluded74 = ["children", "size"],
  _excluded75 = ["children", "size"],
  _excluded76 = ["children", "size"],
  _excluded77 = ["children", "size"],
  _excluded78 = ["children", "size"],
  _excluded79 = ["children", "size"],
  _excluded80 = ["children", "size"],
  _excluded81 = ["children", "size"],
  _excluded82 = ["children", "size"],
  _excluded83 = ["children", "size"],
  _excluded84 = ["children", "size"],
  _excluded85 = ["children", "size"],
  _excluded86 = ["children", "size"],
  _excluded87 = ["children", "size"],
  _excluded88 = ["children", "size"],
  _excluded89 = ["children", "size"],
  _excluded90 = ["children", "size"],
  _excluded91 = ["children", "size"],
  _excluded92 = ["children", "size"],
  _excluded93 = ["children", "size"],
  _excluded94 = ["children", "size"],
  _excluded95 = ["children", "size"],
  _excluded96 = ["children", "size"],
  _excluded97 = ["children", "size"],
  _excluded98 = ["children", "size"],
  _excluded99 = ["children", "size"],
  _excluded100 = ["children", "size"],
  _excluded101 = ["children", "size"],
  _excluded102 = ["children", "size"],
  _excluded103 = ["children", "size"],
  _excluded104 = ["children", "size"],
  _excluded105 = ["children", "size"],
  _excluded106 = ["children", "size"],
  _excluded107 = ["children", "size"],
  _excluded108 = ["children", "size"],
  _excluded109 = ["children", "size"],
  _excluded110 = ["children", "size"],
  _excluded111 = ["children", "size"],
  _excluded112 = ["children", "size"],
  _excluded113 = ["children", "size"],
  _excluded114 = ["children", "size"],
  _excluded115 = ["children", "size"],
  _excluded116 = ["children", "size"],
  _excluded117 = ["children", "size"],
  _excluded118 = ["children", "size"],
  _excluded119 = ["children", "size"],
  _excluded120 = ["children", "size"],
  _excluded121 = ["children", "size"],
  _excluded122 = ["children", "size"],
  _excluded123 = ["children", "size"],
  _excluded124 = ["children", "size"],
  _excluded125 = ["children", "size"];
var Basketball = /*#__PURE__*/React.forwardRef(function Basketball(_ref, ref) {
  var children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM27.9492,15H22.041a14.4088,14.4088,0,0,1,2.7383-7.1533A11.9392,11.9392,0,0,1,27.9492,15ZM17,15V4.0508a11.9181,11.9181,0,0,1,6.2874,2.4375A16.2646,16.2646,0,0,0,20.04,15Zm-2,0H11.96A16.2646,16.2646,0,0,0,8.7126,6.4883,11.9181,11.9181,0,0,1,15,4.0508Zm0,2V27.9492a11.9181,11.9181,0,0,1-6.2874-2.4375A16.2646,16.2646,0,0,0,11.96,17Zm2,0h3.04a16.2646,16.2646,0,0,0,3.2476,8.5117A11.9181,11.9181,0,0,1,17,27.9492ZM7.2207,7.8467A14.4088,14.4088,0,0,1,9.959,15H4.0508A11.9392,11.9392,0,0,1,7.2207,7.8467ZM4.0508,17H9.959a14.4088,14.4088,0,0,1-2.7383,7.1533A11.9392,11.9392,0,0,1,4.0508,17Zm20.7285,7.1533A14.4088,14.4088,0,0,1,22.041,17h5.9082A11.9392,11.9392,0,0,1,24.7793,24.1533Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BastionHost = /*#__PURE__*/React.forwardRef(function BastionHost(_ref2, ref) {
  var children = _ref2.children,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 16 : _ref2$size,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5273,2.709A1.9955,1.9955,0,0,0,26,2H23.3091a1.5,1.5,0,0,0-1.3419.8294L21.3818,4H20V3.5A1.5,1.5,0,0,0,18.5,2h-5A1.5,1.5,0,0,0,12,3.5V4H10.6182l-.585-1.17A1.5017,1.5017,0,0,0,8.69,2H6A2,2,0,0,0,4.0283,4.333L4.7324,8.5A3,3,0,0,0,7.69,11H8V23a3.0033,3.0033,0,0,0-3,3v4H27V26a3.0033,3.0033,0,0,0-3-3V11h.31a3,3,0,0,0,2.9579-2.5l.7041-4.167A1.994,1.994,0,0,0,27.5273,2.709ZM25,26v2H7V26a1.0009,1.0009,0,0,1,1-1H24A1.0009,1.0009,0,0,1,25,26Zm-3-3H10V11H22ZM25.2959,8.167A.9976.9976,0,0,1,24.31,9H7.69a.9976.9976,0,0,1-.9863-.8335L6,4H8.3818l1,2H14V4h4V6h4.6172l1.001-2H26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Bat = /*#__PURE__*/React.forwardRef(function Bat(_ref3, ref) {
  var children = _ref3.children,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? 16 : _ref3$size,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9093,6.584A1,1,0,0,0,31,6c-4.7683,0-8.2607.8887-11,2.8438V3H18V6H14V3H12V8.8438C9.2608,6.8887,5.7684,6,1,6A1,1,0,0,0,.2437,7.6543C1.9454,9.6221,3,11.7041,3,16a1,1,0,0,0,1,1c2.7678,0,6,1.31,6,5a1.004,1.004,0,0,0,.9341.998C11.35,23.0273,15,23.3872,15,27a1,1,0,0,0,2,0c0-3.6128,3.65-3.9727,4.0622-4.002A1,1,0,0,0,22,22c0-3.69,3.2321-5,6-5a1,1,0,0,0,1-1c0-4.2959,1.0547-6.3779,2.7564-8.3457A1,1,0,0,0,31.9093,6.584Zm-4.893,8.46c-3.3857.3081-6.5534,2.229-6.97,6.0786A6.552,6.552,0,0,0,16,23.6094a6.552,6.552,0,0,0-4.0461-2.4864c-.4168-3.85-3.5845-5.7705-6.97-6.0786a13.2017,13.2017,0,0,0-1.9387-6.98c4.1318.2724,7.0327,1.4277,9.248,3.6425A1,1,0,0,0,14,11V8h4v3a1,1,0,0,0,1.707.707c2.2153-2.2148,5.1162-3.37,9.248-3.6425A13.2017,13.2017,0,0,0,27.0163,15.0444Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BatchJob = /*#__PURE__*/React.forwardRef(function BatchJob(_ref4, ref) {
  var children = _ref4.children,
    _ref4$size = _ref4.size,
    size = _ref4$size === void 0 ? 16 : _ref4$size,
    rest = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 26v-2h-2.1011c-.1299-.6372-.3843-1.2285-.7319-1.7529l1.4897-1.4897-1.4141-1.4141-1.4897 1.4897c-.5244-.3477-1.1157-.6021-1.7529-.7319v-2.1011h-2v2.1011c-.6372.1299-1.2285.3843-1.7529.7319l-1.4897-1.4897-1.4141 1.4141 1.4897 1.4897c-.3477.5244-.6021 1.1157-.7319 1.7529h-2.1011v2h2.1011c.1299.6372.3843 1.2285.7319 1.7529l-1.4897 1.4897 1.4141 1.4141 1.4897-1.4897c.5244.3477 1.1157.6021 1.7529.7319v2.1011h2v-2.1011c.6372-.1299 1.2285-.3843 1.7529-.7319l1.4897 1.4897 1.4141-1.4141-1.4897-1.4897c.3477-.5244.6021-1.1157.7319-1.7529h2.1011zm-7 2c-1.6543 0-3-1.3457-3-3s1.3457-3 3-3 3 1.3457 3 3-1.3457 3-3 3zM20 17H12c-1.1046 0-2-.8954-2-2V4c0-1.1046.8954-2 2-2h8c1.1046 0 2 .8954 2 2V15c0 1.1046-.8954 2-2 2zm-8-2h8V4H12V15z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17,21H8c-1.1046,0-2-.8954-2-2V7h2v12h9v2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13,25H4c-1.1028,0-2-.8972-2-2V11h2v12H13v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BatchJobStep = /*#__PURE__*/React.forwardRef(function BatchJobStep(_ref5, ref) {
  var children = _ref5.children,
    _ref5$size = _ref5.size,
    size = _ref5$size === void 0 ? 16 : _ref5$size,
    rest = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20L24 24 20 24 20 28 16 28 16 30 22 30 22 26 26 26 26 22 30 22 30 20 24 20zM8 4h8v6c0 1.1025.8972 2 2 2h6v4h2v-6c0-.2651-.1055-.5195-.293-.707l-7-7c-.1875-.1875-.4419-.293-.707-.293H8c-1.1028 0-2 .8975-2 2V28c0 1.1025.8972 2 2 2h4v-2h-4V4zm15.5857 6h-5.5857V4.4141l5.5857 5.5859z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BatteryCharging = /*#__PURE__*/React.forwardRef(function BatteryCharging(_ref6, ref) {
  var children = _ref6.children,
    _ref6$size = _ref6.size,
    size = _ref6$size === void 0 ? 16 : _ref6$size,
    rest = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27 11H26V10a2 2 0 00-2-2H20v2h4v3h3v6H24v3H19v2h5a2 2 0 002-2V21h1a2 2 0 002-2V13A2 2 0 0027 11zM11 22H6V10h6V8H6a2 2 0 00-2 2V22a2 2 0 002 2h5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.81 23.58L13.19 22.42 17.06 17 9.37 17 16.22 8.38 17.78 9.62 13.51 15 20.94 15 14.81 23.58z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BatteryEmpty = /*#__PURE__*/React.forwardRef(function BatteryEmpty(_ref7, ref) {
  var children = _ref7.children,
    _ref7$size = _ref7.size,
    size = _ref7$size === void 0 ? 16 : _ref7$size,
    rest = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24H6a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,6,8H24a2.0023,2.0023,0,0,1,2,2v1h1a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H26v1A2.0027,2.0027,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BatteryFull = /*#__PURE__*/React.forwardRef(function BatteryFull(_ref8, ref) {
  var children = _ref8.children,
    _ref8$size = _ref8.size,
    size = _ref8$size === void 0 ? 16 : _ref8$size,
    rest = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24H6a2,2,0,0,1-2-2V10A2,2,0,0,1,6,8H24a2,2,0,0,1,2,2v1h1a2,2,0,0,1,2,2v6a2,2,0,0,1-2,2H26v1A2,2,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9H19V23H11z",
    transform: "rotate(90 15 16)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BatteryHalf = /*#__PURE__*/React.forwardRef(function BatteryHalf(_ref9, ref) {
  var children = _ref9.children,
    _ref9$size = _ref9.size,
    size = _ref9$size === void 0 ? 16 : _ref9$size,
    rest = _objectWithoutProperties(_ref9, _excluded9);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24H6a2,2,0,0,1-2-2V10A2,2,0,0,1,6,8H24a2,2,0,0,1,2,2v1h1a2,2,0,0,1,2,2v6a2,2,0,0,1-2,2H26v1A2,2,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12H16V20H8z",
    transform: "rotate(90 12 16)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BatteryLow = /*#__PURE__*/React.forwardRef(function BatteryLow(_ref10, ref) {
  var children = _ref10.children,
    _ref10$size = _ref10.size,
    size = _ref10$size === void 0 ? 16 : _ref10$size,
    rest = _objectWithoutProperties(_ref10, _excluded10);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24H6a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,6,8H24a2.0023,2.0023,0,0,1,2,2v1h1a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H26v1A2.0027,2.0027,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15H13V17H5z",
    transform: "rotate(90 9 16)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BatteryQuarter = /*#__PURE__*/React.forwardRef(function BatteryQuarter(_ref11, ref) {
  var children = _ref11.children,
    _ref11$size = _ref11.size,
    size = _ref11$size === void 0 ? 16 : _ref11$size,
    rest = _objectWithoutProperties(_ref11, _excluded11);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24H6a2.0023,2.0023,0,0,1-2-2V10A2.002,2.002,0,0,1,6,8H24a2.0023,2.0023,0,0,1,2,2v1h1a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H26v1A2.0027,2.0027,0,0,1,24,24ZM6,10V22H24V19h3V13H24V10Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14H14V18H6z",
    transform: "rotate(90 10 16)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Bee = /*#__PURE__*/React.forwardRef(function Bee(_ref12, ref) {
  var children = _ref12.children,
    _ref12$size = _ref12.size,
    size = _ref12$size === void 0 ? 16 : _ref12$size,
    rest = _objectWithoutProperties(_ref12, _excluded12);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10a6 6 0 00-6 6v8a6 6 0 0012 0V16A6 6 0 0016 10zm-4.25 7.87h8.5v4.25h-8.5zM16 28.25A4.27 4.27 0 0111.75 24v-.13h8.5V24A4.27 4.27 0 0116 28.25zm4.25-12.13h-8.5V16a4.25 4.25 0 018.5 0zM30.66 19.21L24 13v9.1a4 4 0 008 0A3.83 3.83 0 0030.66 19.21zM28 24.35a2.25 2.25 0 01-2.25-2.25V17l3.72 3.47h0A2.05 2.05 0 0130.2 22 2.25 2.25 0 0128 24.35zM0 22.1a4 4 0 008 0V13L1.34 19.21A3.88 3.88 0 000 22.1zm2.48-1.56h0L6.25 17v5.1a2.25 2.25 0 01-4.5 0A2.05 2.05 0 012.48 20.54zM15 5.5A3.5 3.5 0 1011.5 9 3.5 3.5 0 0015 5.5zm-5.25 0A1.75 1.75 0 1111.5 7.25 1.77 1.77 0 019.75 5.5zM20.5 2A3.5 3.5 0 1024 5.5 3.5 3.5 0 0020.5 2zm0 5.25A1.75 1.75 0 1122.25 5.5 1.77 1.77 0 0120.5 7.25z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BeeBat = /*#__PURE__*/React.forwardRef(function BeeBat(_ref13, ref) {
  var children = _ref13.children,
    _ref13$size = _ref13.size,
    size = _ref13$size === void 0 ? 16 : _ref13$size,
    rest = _objectWithoutProperties(_ref13, _excluded13);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "8",
    r: "2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "8",
    r: "2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8083,8.665A.8745.8745,0,0,0,31,8.125H29c-4.21,0-7.721,2.002-9.1648,4.9014a4.8186,4.8186,0,0,0-7.67,0C10.721,10.127,7.21,8.125,3,8.125H1A.8749.8749,0,0,0,.3816,9.6191L.4834,9.72A5.3885,5.3885,0,0,1,2.1612,15.751.8751.8751,0,0,0,3,16.875a2.8966,2.8966,0,0,1,2.1587.7266c.9783.9814.9714,2.8872.9668,4.1479l0,.25A.875.875,0,0,0,7,22.875h4.125V23a4.875,4.875,0,0,0,9.75,0v-.125H25A.875.875,0,0,0,25.875,22l0-.25c-.0046-1.2607-.0115-3.1665.9668-4.1479A2.8966,2.8966,0,0,1,29,16.875a.8751.8751,0,0,0,.8388-1.124,5.3883,5.3883,0,0,1,1.6765-6.0293l.1033-.103A.875.875,0,0,0,31.8083,8.665ZM16,12.875A3.1286,3.1286,0,0,1,19.125,16v.125h-6.25V16A3.1286,3.1286,0,0,1,16,12.875Zm-3.125,5h6.25v3.25h-6.25Zm-5.0007,3.25c-.0178-1.459-.1839-3.4619-1.4761-4.7588a4.1876,4.1876,0,0,0-2.31-1.1518A6.657,6.657,0,0,0,2.9524,9.875H3c4.5562,0,8.125,2.69,8.125,6.125v5.125ZM19.125,23a3.125,3.125,0,0,1-6.25,0v-.125h6.25Zm8.7868-7.7856a4.1876,4.1876,0,0,0-2.31,1.1518c-1.2922,1.2969-1.4583,3.3-1.4761,4.7588H20.875V16c0-3.4346,3.5688-6.125,8.125-6.125h.0481A6.6561,6.6561,0,0,0,27.9118,15.2144Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Beta = /*#__PURE__*/React.forwardRef(function Beta(_ref14, ref) {
  var children = _ref14.children,
    _ref14$size = _ref14.size,
    size = _ref14$size === void 0 ? 16 : _ref14$size,
    rest = _objectWithoutProperties(_ref14, _excluded14);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7168,13.7705A5.9174,5.9174,0,0,0,23,9c0-3.5327-2.8784-6-7-6a6.627,6.627,0,0,0-7,7V31h2V25.1206a8.1261,8.1261,0,0,0,6,2.48A7.3833,7.3833,0,0,0,24.6528,20,6.6364,6.6364,0,0,0,20.7168,13.7705ZM17,25.6A5.6781,5.6781,0,0,1,11,20V10a4.6856,4.6856,0,0,1,5-5c3.0374,0,5,1.57,5,4a3.8732,3.8732,0,0,1-4,4v2c3.4341,0,5.6528,1.9629,5.6528,5A5.3907,5.3907,0,0,1,17,25.6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Bicycle = /*#__PURE__*/React.forwardRef(function Bicycle(_ref15, ref) {
  var children = _ref15.children,
    _ref15$size = _ref15.size,
    size = _ref15$size === void 0 ? 16 : _ref15$size,
    rest = _objectWithoutProperties(_ref15, _excluded15);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16c-.0879,0-.1731.0093-.26.0132L24.2368,9H28V7H23a1,1,0,0,0-.978,1.21L22.62,11H12.3872l-1-3H14V6H7V8H9.28l1.0411,3.123-2.57,5.1392A6,6,0,1,0,11.91,23h2.61a1.991,1.991,0,0,0,1.5616-.75L23.14,13.4258l.6436,3.0039A5.9891,5.9891,0,1,0,26,16ZM6,26a4,4,0,1,1,.8364-7.9092L5.1055,21.5527l.009.0044A.9834.9834,0,0,0,5,22a.9931.9931,0,0,0,1.8853.4429l.0092.0044L8.6182,19A3.9835,3.9835,0,0,1,6,26Zm5.91-5a5.9986,5.9986,0,0,0-2.3733-3.8364l1.6787-3.3574L13.613,21Zm3.4577-1.06L13.054,13h7.8654ZM26,26a3.9882,3.9882,0,0,1-1.7859-7.56l.8079,3.77.02-.0044A.9859.9859,0,0,0,26,23a1,1,0,0,0,1-1,.9456.9456,0,0,0-.0415-.2056l.02-.0044-.8086-3.7729A3.9931,3.9931,0,0,1,26,26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Binoculars = /*#__PURE__*/React.forwardRef(function Binoculars(_ref16, ref) {
  var children = _ref16.children,
    _ref16$size = _ref16.size,
    size = _ref16$size === void 0 ? 16 : _ref16$size,
    rest = _objectWithoutProperties(_ref16, _excluded16);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8V5a1,1,0,0,0-1-1H21a1,1,0,0,0-1,1V8a2,2,0,0,0-2,2v2H14V10a2,2,0,0,0-2-2V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V8a2,2,0,0,0-2,2V22a2,2,0,0,0,1,1.72V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V23.72A2,2,0,0,0,14,22V20h4v2a2,2,0,0,0,1,1.72V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V23.72A2,2,0,0,0,30,22V10A2,2,0,0,0,28,8ZM11,26H5V24h6Zm1-4H4V10H6V6h4v4h2Zm2-4V14h4v4Zm13,8H21V24h6Zm1-4H20V10h2V6h4v4h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var QBlochSphere = /*#__PURE__*/React.forwardRef(function QBlochSphere(_ref17, ref) {
  var children = _ref17.children,
    _ref17$size = _ref17.size,
    size = _ref17$size === void 0 ? 16 : _ref17$size,
    rest = _objectWithoutProperties(_ref17, _excluded17);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21.87,7.84l-1.74-1L16,14h0a2,2,0,1,0,2,2,2,2,0,0,0-.27-1Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,2a12,12,0,0,1,11.17,7.65,25.69,25.69,0,0,0-3.69-1.5l-1,1.77a22.7,22.7,0,0,1,5.41,2.39,11.05,11.05,0,0,1,0,3.38A22.92,22.92,0,0,1,16,21,22.92,22.92,0,0,1,4.13,17.69a11.05,11.05,0,0,1,0-3.38A22.8,22.8,0,0,1,15,11V9a25,25,0,0,0-10.17,2.6A12,12,0,0,1,16,4Zm0,24A12,12,0,0,1,4.83,20.35,24.88,24.88,0,0,0,16,23a24.88,24.88,0,0,0,11.17-2.65A12,12,0,0,1,16,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BlockStorage = /*#__PURE__*/React.forwardRef(function BlockStorage(_ref18, ref) {
  var children = _ref18.children,
    _ref18$size = _ref18.size,
    size = _ref18$size === void 0 ? 16 : _ref18$size,
    rest = _objectWithoutProperties(_ref18, _excluded18);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M9,12V10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V19H20v9H4V12"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12H14V4h8zM12 4v8a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2H14A2 2 0 0012 4zM14 18v4H10V18h4M8 18v4a2 2 0 002 2h4a2 2 0 002-2V18a2 2 0 00-2-2H10A2 2 0 008 18zM28 17v2H26V17h2m-4-1v4a1 1 0 001 1h4a1 1 0 001-1V16a1 1 0 00-1-1H25A1 1 0 0024 16z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BlockStorageAlt = /*#__PURE__*/React.forwardRef(function BlockStorageAlt(_ref19, ref) {
  var children = _ref19.children,
    _ref19$size = _ref19.size,
    size = _ref19$size === void 0 ? 16 : _ref19$size,
    rest = _objectWithoutProperties(_ref19, _excluded19);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20H8V13h7zm-5-2h3V15H10zM24 20H17V13h7zm-5-2h3V15H19zM15 11H8V4h7zM10 9h3V6H10zM24 11H17V4h7zM19 9h3V6H19z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Blockchain = /*#__PURE__*/React.forwardRef(function Blockchain(_ref20, ref) {
  var children = _ref20.children,
    _ref20$size = _ref20.size,
    size = _ref20$size === void 0 ? 16 : _ref20$size,
    rest = _objectWithoutProperties(_ref20, _excluded20);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M6,24H4V8H6ZM28,8H26V24h2ZM24,6V4H8V6Zm0,22V26H8v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Blog = /*#__PURE__*/React.forwardRef(function Blog(_ref21, ref) {
  var children = _ref21.children,
    _ref21$size = _ref21.size,
    size = _ref21$size === void 0 ? 16 : _ref21$size,
    rest = _objectWithoutProperties(_ref21, _excluded21);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M4 24H14V26H4zM4 18H14V20H4zM26 14H6a2 2 0 01-2-2V6A2 2 0 016 4H26a2 2 0 012 2v6A2 2 0 0126 14zM6 6v6H26V6zM26 28H20a2 2 0 01-2-2V20a2 2 0 012-2h6a2 2 0 012 2v6A2 2 0 0126 28zm-6-8v6h6V20z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Bluetooth = /*#__PURE__*/React.forwardRef(function Bluetooth(_ref22, ref) {
  var children = _ref22.children,
    _ref22$size = _ref22.size,
    size = _ref22$size === void 0 ? 16 : _ref22$size,
    rest = _objectWithoutProperties(_ref22, _excluded22);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30a1.06,1.06,0,0,1-.42-.09A1,1,0,0,1,15,29V18.41L8.41,25,7,23.59,14.59,16,7,8.41,8.41,7,15,13.59V3a1,1,0,0,1,.58-.91,1,1,0,0,1,1.07.15l7,6A1,1,0,0,1,24,9a1,1,0,0,1-.29.75L17.41,16l6.3,6.29A1,1,0,0,1,24,23a1,1,0,0,1-.35.72l-7,6A1,1,0,0,1,16,30Zm1-11.59v8.42l4.53-3.89ZM17,5.17v8.42l4.53-4.53Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BluetoothOff = /*#__PURE__*/React.forwardRef(function BluetoothOff(_ref23, ref) {
  var children = _ref23.children,
    _ref23$size = _ref23.size,
    size = _ref23$size === void 0 ? 16 : _ref23$size,
    rest = _objectWithoutProperties(_ref23, _excluded23);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M28 26.59L5.41 4 4 5.41 14.59 16 7 23.59 8.41 25 15 18.41V29a1 1 0 00.58.91A1.06 1.06 0 0016 30a1 1 0 00.65-.24l6.3-5.4L26.59 28zm-11 .24V18.41l4.53 4.53zM17 12.75V5.17l4.53 3.89-4.11 4.11 1.41 1.41 4.88-4.87A1 1 0 0024 9a1 1 0 00-.35-.72l-7-6a1 1 0 00-1.07-.15A1 1 0 0015 3v7.75z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Book = /*#__PURE__*/React.forwardRef(function Book(_ref24, ref) {
  var children = _ref24.children,
    _ref24$size = _ref24.size,
    size = _ref24$size === void 0 ? 16 : _ref24$size,
    rest = _objectWithoutProperties(_ref24, _excluded24);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10H26V12H19zM19 15H26V17H19zM19 20H26V22H19zM6 10H13V12H6zM6 15H13V17H6zM6 20H13V22H6z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M28,5H4A2.002,2.002,0,0,0,2,7V25a2.002,2.002,0,0,0,2,2H28a2.002,2.002,0,0,0,2-2V7A2.002,2.002,0,0,0,28,5ZM4,7H15V25H4ZM17,25V7H28V25Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Bookmark = /*#__PURE__*/React.forwardRef(function Bookmark(_ref25, ref) {
  var children = _ref25.children,
    _ref25$size = _ref25.size,
    size = _ref25$size === void 0 ? 16 : _ref25$size,
    rest = _objectWithoutProperties(_ref25, _excluded25);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M24,4V26.75l-7.1-3.59-.9-.45-.9.45L8,26.75V4H24m0-2H8A2,2,0,0,0,6,4V30L16,25,26,30V4A2,2,0,0,0,24,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BookmarkAdd = /*#__PURE__*/React.forwardRef(function BookmarkAdd(_ref26, ref) {
  var children = _ref26.children,
    _ref26$size = _ref26.size,
    size = _ref26$size === void 0 ? 16 : _ref26$size,
    rest = _objectWithoutProperties(_ref26, _excluded26);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M24,16V26.7515l-7.0962-3.5894L16,22.7051l-.9009.456L8,26.748V4H18V2H8A2,2,0,0,0,6,4V30l10-5.0537L26,30V16Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M26 6L26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6 26 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BookmarkFilled = /*#__PURE__*/React.forwardRef(function BookmarkFilled(_ref27, ref) {
  var children = _ref27.children,
    _ref27$size = _ref27.size,
    size = _ref27$size === void 0 ? 16 : _ref27$size,
    rest = _objectWithoutProperties(_ref27, _excluded27);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M24,2H8A2,2,0,0,0,6,4V30l10-5.0538L26,30V4A2,2,0,0,0,24,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Boolean = /*#__PURE__*/React.forwardRef(function Boolean(_ref28, ref) {
  var children = _ref28.children,
    _ref28$size = _ref28.size,
    size = _ref28$size === void 0 ? 16 : _ref28$size,
    rest = _objectWithoutProperties(_ref28, _excluded28);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M23,23a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,23,23Zm0-12a5,5,0,1,0,5,5A5.0055,5.0055,0,0,0,23,11Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "16",
    r: "7"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Boot = /*#__PURE__*/React.forwardRef(function Boot(_ref29, ref) {
  var children = _ref29.children,
    _ref29$size = _ref29.size,
    size = _ref29$size === void 0 ? 16 : _ref29$size,
    rest = _objectWithoutProperties(_ref29, _excluded29);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M24,17H18a1.0008,1.0008,0,0,1-1-1V4a2.0025,2.0025,0,0,0-2-2H5A2.0025,2.0025,0,0,0,3,4V28a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V22A5.0057,5.0057,0,0,0,24,17Zm3,5v2H23V19h1A3.0033,3.0033,0,0,1,27,22ZM15,4V6H11V8h4v2H11v2h4v2H11v2h4a3.0033,3.0033,0,0,0,3,3h3v5H14.1624l-3-1H5V4ZM25,28V27H23v1H21V27H19v1H17V27H15v1H13V27H11v1H5V25h5.8376l3,1H27v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BootVolume = /*#__PURE__*/React.forwardRef(function BootVolume(_ref30, ref) {
  var children = _ref30.children,
    _ref30$size = _ref30.size,
    size = _ref30$size === void 0 ? 16 : _ref30$size,
    rest = _objectWithoutProperties(_ref30, _excluded30);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M32 22v-2h-3v-2h-2v2h-1v2h1v6c0 1.1025.8975 2 2 2h3v-2h-3v-6h3zM23 30h-3c-1.1025 0-2-.8975-2-2v-6c0-1.103.8975-2 2-2h3c1.1025 0 2 .897 2 2v6c0 1.1025-.8975 2-2 2zm-3-8v6h3v-6h-3zM14 30h-3c-1.1025 0-2-.8975-2-2v-6c0-1.103.8975-2 2-2h3c1.1025 0 2 .897 2 2v6c0 1.1025-.8975 2-2 2zm-3-8v6h3v-6h-3zM5 20H2v-4H0v14H5c1.1025 0 2-.8975 2-2v-6c0-1.103-.8975-2-2-2zm-3 8v-6h3v6H2zM4 14V5h7.5857l4 4h12.4143v7h2v-7c-.0013-1.1041-.8959-1.9987-2-2h-11.5857l-3.4143-3.4141c-.3742-.3764-.8835-.5873-1.4143-.5859H4c-1.1041.0013-1.9987.8959-2 2V14h2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BootVolumeAlt = /*#__PURE__*/React.forwardRef(function BootVolumeAlt(_ref31, ref) {
  var children = _ref31.children,
    _ref31$size = _ref31.size,
    size = _ref31$size === void 0 ? 16 : _ref31$size,
    rest = _objectWithoutProperties(_ref31, _excluded31);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30h-7c-1.1028,0-2-.8972-2-2v-2h2v2h7v-7h-2v-2h2c1.1028,0,2,.8972,2,2v7c0,1.1028-.8972,2-2,2Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24L14 24 13.9998 17.414 22.5823 26 24 24.5857 15.4139 15.9998 22 16 22 14 12 14 12 24z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M8,27H4c-1.104-.0013-1.9987-.896-2-2V5c.0013-1.104,.896-1.9987,2-2h7.5857c.5308-.0015,1.0401,.2095,1.4143,.5859l3.4143,3.4141h11.5857c1.104,.0013,1.9987,.896,2,2v7h-2v-7H15.5857l-4-4H4V25h4v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BorderBottom = /*#__PURE__*/React.forwardRef(function BorderBottom(_ref32, ref) {
  var children = _ref32.children,
    _ref32$size = _ref32.size,
    size = _ref32$size === void 0 ? 16 : _ref32$size,
    rest = _objectWithoutProperties(_ref32, _excluded32);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M3 27H29V29H3z",
    transform: "rotate(180 16 28)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M27 23H29V25H27z",
    transform: "rotate(180 28 24)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M27 19H29V21H27z",
    transform: "rotate(180 28 20)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15H29V17H27z",
    transform: "rotate(180 28 16)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M27 11H29V13H27z",
    transform: "rotate(180 28 12)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M27 7H29V9H27z",
    transform: "rotate(180 28 8)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M27 3H29V5H27z",
    transform: "rotate(180 28 4)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M23 3H25V5H23z",
    transform: "rotate(180 24 4)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3H21V5H19z",
    transform: "rotate(180 20 4)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3H17V5H15z",
    transform: "rotate(180 16 4)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3H9V5H7z",
    transform: "rotate(180 8 4)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3H13V5H11z",
    transform: "rotate(180 12 4)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M3 23H5V25H3z",
    transform: "rotate(180 4 24)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19H5V21H3z",
    transform: "rotate(180 4 20)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15H5V17H3z",
    transform: "rotate(180 4 16)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11H5V13H3z",
    transform: "rotate(180 4 12)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7H5V9H3z",
    transform: "rotate(180 4 8)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3H5V5H3z",
    transform: "rotate(180 4 4)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H18V12H8zM8 15H14V17H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BorderFull = /*#__PURE__*/React.forwardRef(function BorderFull(_ref33, ref) {
  var children = _ref33.children,
    _ref33$size = _ref33.size,
    size = _ref33$size === void 0 ? 16 : _ref33$size,
    rest = _objectWithoutProperties(_ref33, _excluded33);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H18V12H8zM8 15H14V17H8z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M29,29H3V3H29ZM5,27H27V5H5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BorderLeft = /*#__PURE__*/React.forwardRef(function BorderLeft(_ref34, ref) {
  var children = _ref34.children,
    _ref34$size = _ref34.size,
    size = _ref34$size === void 0 ? 16 : _ref34$size,
    rest = _objectWithoutProperties(_ref34, _excluded34);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M-9 15H17V17H-9z",
    transform: "rotate(-90 4 16)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M7 27H9V29H7z",
    transform: "rotate(-90 8 28)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M11 27H13V29H11z",
    transform: "rotate(-90 12 28)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M15 27H17V29H15z",
    transform: "rotate(-90 16 28)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M19 27H21V29H19z",
    transform: "rotate(-90 20 28)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27H25V29H23z",
    transform: "rotate(-90 24 28)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M27 27H29V29H27z",
    transform: "rotate(-90 28 28)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M27 23H29V25H27z",
    transform: "rotate(-90 28 24)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M27 19H29V21H27z",
    transform: "rotate(-90 28 20)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15H29V17H27z",
    transform: "rotate(-90 28 16)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M27 7H29V9H27z",
    transform: "rotate(-90 28 8)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M27 11H29V13H27z",
    transform: "rotate(-90 28 12)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3H9V5H7z",
    transform: "rotate(-90 8 4)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3H13V5H11z",
    transform: "rotate(-90 12 4)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3H17V5H15z",
    transform: "rotate(-90 16 4)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3H21V5H19z",
    transform: "rotate(-90 20 4)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M23 3H25V5H23z",
    transform: "rotate(-90 24 4)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M27 3H29V5H27z",
    transform: "rotate(-90 28 4)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H18V12H8zM8 15H14V17H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BorderNone = /*#__PURE__*/React.forwardRef(function BorderNone(_ref35, ref) {
  var children = _ref35.children,
    _ref35$size = _ref35.size,
    size = _ref35$size === void 0 ? 16 : _ref35$size,
    rest = _objectWithoutProperties(_ref35, _excluded35);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3H5V5H3zM7 3H9V5H7zM11 3H13V5H11zM15 3H17V5H15zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3zM27 3H29V5H27zM23 3H25V5H23zM19 3H21V5H19zM7 27H9V29H7zM11 27H13V29H11zM15 27H17V29H15zM23 27H25V29H23zM19 27H21V29H19zM27 7H29V9H27zM27 11H29V13H27zM27 15H29V17H27zM27 19H29V21H27zM27 23H29V25H27zM27 27H29V29H27zM8 10H18V12H8zM8 15H14V17H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BorderRight = /*#__PURE__*/React.forwardRef(function BorderRight(_ref36, ref) {
  var children = _ref36.children,
    _ref36$size = _ref36.size,
    size = _ref36$size === void 0 ? 16 : _ref36$size,
    rest = _objectWithoutProperties(_ref36, _excluded36);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15H41V17H15z",
    transform: "rotate(90 28 16)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M23 3H25V5H23z",
    transform: "rotate(90 24 4)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3H21V5H19z",
    transform: "rotate(90 20 4)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3H17V5H15z",
    transform: "rotate(90 16 4)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3H13V5H11z",
    transform: "rotate(90 12 4)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3H9V5H7z",
    transform: "rotate(90 8 4)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3H5V5H3z",
    transform: "rotate(90 4 4)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7H5V9H3z",
    transform: "rotate(90 4 8)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11H5V13H3z",
    transform: "rotate(90 4 12)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15H5V17H3z",
    transform: "rotate(90 4 16)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M3 23H5V25H3z",
    transform: "rotate(90 4 24)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19H5V21H3z",
    transform: "rotate(90 4 20)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27H25V29H23z",
    transform: "rotate(90 24 28)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M19 27H21V29H19z",
    transform: "rotate(90 20 28)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M15 27H17V29H15z",
    transform: "rotate(90 16 28)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M11 27H13V29H11z",
    transform: "rotate(90 12 28)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M7 27H9V29H7z",
    transform: "rotate(90 8 28)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M3 27H5V29H3z",
    transform: "rotate(90 4 28)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H18V12H8zM8 15H14V17H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BorderTop = /*#__PURE__*/React.forwardRef(function BorderTop(_ref37, ref) {
  var children = _ref37.children,
    _ref37$size = _ref37.size,
    size = _ref37$size === void 0 ? 16 : _ref37$size,
    rest = _objectWithoutProperties(_ref37, _excluded37);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3H29V5H3zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3zM7 27H9V29H7zM11 27H13V29H11zM15 27H17V29H15zM23 27H25V29H23zM19 27H21V29H19zM27 7H29V9H27zM27 11H29V13H27zM27 15H29V17H27zM27 19H29V21H27zM27 23H29V25H27zM27 27H29V29H27zM8 10H18V12H8zM8 15H14V17H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Bot = /*#__PURE__*/React.forwardRef(function Bot(_ref38, ref) {
  var children = _ref38.children,
    _ref38$size = _ref38.size,
    size = _ref38$size === void 0 ? 16 : _ref38$size,
    rest = _objectWithoutProperties(_ref38, _excluded38);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10H20V12H18zM12 10H14V12H12z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20H21V18h1a2.0023,2.0023,0,0,0,2-2V12h2V10H24V8a2.0023,2.0023,0,0,0-2-2H20V2H18V6H14V2H12V6H10A2.0023,2.0023,0,0,0,8,8v2H6v2H8v4a2.0023,2.0023,0,0,0,2,2h1v2H6a2.0023,2.0023,0,0,0-2,2v8H6V22H26v8h2V22A2.0023,2.0023,0,0,0,26,20ZM10,8H22v8H10Zm3,10h6v2H13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Bottles_01 = /*#__PURE__*/React.forwardRef(function Bottles_01(_ref39, ref) {
  var children = _ref39.children,
    _ref39$size = _ref39.size,
    size = _ref39$size === void 0 ? 16 : _ref39$size,
    rest = _objectWithoutProperties(_ref39, _excluded39);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M26 9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3 .5066 3 4.2793v13h-3v2h4c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zM19 9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3 .5066 3 4.2793v13h-3v2h4c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zM12 9.3706V3c0-.5522-.4478-1-1-1H7c-.5522 0-1 .4478-1 1v6.3706c-1.0674.6055-3 2.1777-3 5.6294v14c0 .5522.4478 1 1 1H14c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zm1 18.6294H5V15c0-3.7725 3-4.2793 3-4.2793V4h2v6.7207s3 .5068 3 4.2793v13z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Bottles_01Dash = /*#__PURE__*/React.forwardRef(function Bottles_01Dash(_ref40, ref) {
  var children = _ref40.children,
    _ref40$size = _ref40.size,
    size = _ref40$size === void 0 ? 16 : _ref40$size,
    rest = _objectWithoutProperties(_ref40, _excluded40);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M26 9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3 .5066 3 4.2793v13h-3v2h4c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zM19 9.3706V3c0-.5522-.4478-1-1-1h-3v2h2v6.7207s3 .5066 3 4.2793v13h-3v2h4c.5522 0 1-.4478 1-1V15c0-3.4517-1.9326-5.0239-3-5.6294zM13 28h-3v2h4c.5522 0 1-.4478 1-1v-4h-2v3zM5 25H3v4c0 .5522.4478 1 1 1h4v-2h-3v-3zM13 18H15V23H13zM3 18H5V23H3zM12 9.3706V3c0-.5522-.4478-1-1-1H7c-.5522 0-1 .4478-1 1v6.3706c-1.0674.6055-3 2.1777-3 5.6294v1h2v-1c0-3.7725 3-4.2793 3-4.2793V4h2v6.7207s3 .5068 3 4.2793v1h2v-1c0-3.4517-1.9326-5.0239-3-5.6294z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Bottles_02 = /*#__PURE__*/React.forwardRef(function Bottles_02(_ref41, ref) {
  var children = _ref41.children,
    _ref41$size = _ref41.size,
    size = _ref41$size === void 0 ? 16 : _ref41$size,
    rest = _objectWithoutProperties(_ref41, _excluded41);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M24 9.0513v-3.0513c0-.5522-.4478-1-1-1h-3v2h2v3.02s2 1.1238 2 3.48v11.5h-4v2h5c.5522 0 1-.4478 1-1V13.5c0-1.7129-.7229-3.3076-2-4.4487zM16 9.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522 0-1 .4478-1 1v3.0513c-1.2771 1.1411-2 2.7358-2 4.4487v12.5c0 .5522.4478 1 1 1h10c.5522 0 1-.4478 1-1V13.5c0-1.7129-.7229-3.3076-2-4.4487zm0 15.9487H8V13.5c0-2.356 2-3.48 2-3.48v-3.02h4v3.02s2 1.124 2 3.48v11.5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Bottles_02Dash = /*#__PURE__*/React.forwardRef(function Bottles_02Dash(_ref42, ref) {
  var children = _ref42.children,
    _ref42$size = _ref42.size,
    size = _ref42$size === void 0 ? 16 : _ref42$size,
    rest = _objectWithoutProperties(_ref42, _excluded42);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M24 9.0513v-3.0513c0-.5522-.4478-1-1-1h-3v2h2v3.02s2 1.1238 2 3.48v11.5h-4v2h5c.5522 0 1-.4478 1-1V13.5c0-1.7129-.7229-3.3076-2-4.4487zM16 25h-3v2h4c.5522 0 1-.4478 1-1v-4h-2v3zM8 22h-2v4c0 .5522.4478 1 1 1h4v-2h-3v-3zM16 16H18V20H16zM6 16H8V20H6zM16 9.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522 0-1 .4478-1 1v3.0513c-1.2771 1.1411-2 2.7358-2 4.4487v.5h2v-.5c0-2.356 2-3.48 2-3.48v-3.02h4v3.02s2 1.124 2 3.48v.5h2v-.5c0-1.7129-.7229-3.3076-2-4.4487z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BottlesContainer = /*#__PURE__*/React.forwardRef(function BottlesContainer(_ref43, ref) {
  var children = _ref43.children,
    _ref43$size = _ref43.size,
    size = _ref43$size === void 0 ? 16 : _ref43$size,
    rest = _objectWithoutProperties(_ref43, _excluded43);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M23 10v-2c0-.5522-.4478-1-1-1h-3v2h2v1.9688s2 1.1238 2 3.48v8.5513h-4v2h5c.5522 0 1-.4478 1-1V14.4487c0-1.7129-.7229-3.3076-2-4.4487zM15 10v-2c0-.5522-.4478-1-1-1h-4c-.5522 0-1 .4478-1 1v2c-1.2771 1.1411-2 2.7358-2 4.4487v9.5513c0 .5522.4478 1 1 1h8c.5522 0 1-.4478 1-1V14.4487c0-1.7129-.7229-3.3076-2-4.4487zm0 13h-6V14.4487c0-2.356 2-3.48 2-3.48v-1.9688h2v1.9688s2 1.124 2 3.48v8.5513z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4c-1.1046,0-2,.8954-2,2V28c0,1.1046,.8954,2,2,2H28c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2Zm0,26H4V4H28V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Box = /*#__PURE__*/React.forwardRef(function Box(_ref44, ref) {
  var children = _ref44.children,
    _ref44$size = _ref44.size,
    size = _ref44$size === void 0 ? 16 : _ref44$size,
    rest = _objectWithoutProperties(_ref44, _excluded44);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M20,21H12a2,2,0,0,1-2-2V17a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2v2A2,2,0,0,1,20,21Zm-8-4v2h8V17Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6v4a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V12a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM26,28H6V12H26Zm2-18H4V6H28v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BoxExtraLarge = /*#__PURE__*/React.forwardRef(function BoxExtraLarge(_ref45, ref) {
  var children = _ref45.children,
    _ref45$size = _ref45.size,
    size = _ref45$size === void 0 ? 16 : _ref45$size,
    rest = _objectWithoutProperties(_ref45, _excluded45);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M19 21L19 9 17 9 17 23 24 23 24 21 19 21zM16 9L14 9 12 15 10 9 8 9 10.752 16 8 23 10 23 12 17 14 23 16 23 13.245 16 16 9zM4 4H28V6H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BoxLarge = /*#__PURE__*/React.forwardRef(function BoxLarge(_ref46, ref) {
  var children = _ref46.children,
    _ref46$size = _ref46.size,
    size = _ref46$size === void 0 ? 16 : _ref46$size,
    rest = _objectWithoutProperties(_ref46, _excluded46);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21L14 9 12 9 12 23 20 23 20 21 14 21zM4 4H28V6H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BoxMedium = /*#__PURE__*/React.forwardRef(function BoxMedium(_ref47, ref) {
  var children = _ref47.children,
    _ref47$size = _ref47.size,
    size = _ref47$size === void 0 ? 16 : _ref47$size,
    rest = _objectWithoutProperties(_ref47, _excluded47);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9L16.485 14 16 15.977 15.535 14 14 9 12 9 12 23 14 23 14 15 13.842 13.004 14.421 15 16 19.626 17.579 15 18.159 13 18 15 18 23 20 23 20 9 18 9zM4 4H28V6H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BoxSmall = /*#__PURE__*/React.forwardRef(function BoxSmall(_ref48, ref) {
  var children = _ref48.children,
    _ref48$size = _ref48.size,
    size = _ref48$size === void 0 ? 16 : _ref48$size,
    rest = _objectWithoutProperties(_ref48, _excluded48);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0021,2.0021,0,0,1-2-2V9H6V26H26V9h2V26A2.0021,2.0021,0,0,1,26,28Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23H12V21h6V17H14a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H14v4h4a2.002 2.002 0 012 2v4A2.0023 2.0023 0 0118 23zM4 4H28V6H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BoxPlot = /*#__PURE__*/React.forwardRef(function BoxPlot(_ref49, ref) {
  var children = _ref49.children,
    _ref49$size = _ref49.size,
    size = _ref49$size === void 0 ? 16 : _ref49$size,
    rest = _objectWithoutProperties(_ref49, _excluded49);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M22,6V4H12V6h4V8H12V20h4v2H12v2H22V22H18V20h4V8H18V6ZM14,18V15h6v3Zm6-5H14V10h6Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Branch = /*#__PURE__*/React.forwardRef(function Branch(_ref50, ref) {
  var children = _ref50.children,
    _ref50$size = _ref50.size,
    size = _ref50$size === void 0 ? 16 : _ref50$size,
    rest = _objectWithoutProperties(_ref50, _excluded50);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18a3.9955,3.9955,0,0,0-3.858,3H18a3.0033,3.0033,0,0,1-3-3V14a4.9514,4.9514,0,0,0-1.0256-3H22.142a4,4,0,1,0,0-2H9.858a4,4,0,1,0,0,2H10a3.0033,3.0033,0,0,1,3,3v4a5.0059,5.0059,0,0,0,5,5h4.142A3.9935,3.9935,0,1,0,26,18ZM26,8a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,8ZM6,12a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,12ZM26,24a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BreakingChange = /*#__PURE__*/React.forwardRef(function BreakingChange(_ref51, ref) {
  var children = _ref51.children,
    _ref51$size = _ref51.size,
    size = _ref51$size === void 0 ? 16 : _ref51$size,
    rest = _objectWithoutProperties(_ref51, _excluded51);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M31 25a6 6 0 10-6 6A6.0066 6.0066 0 0031 25zm-2 0a3.9521 3.9521 0 01-.5669 2.019L22.981 21.5669A3.9529 3.9529 0 0125 21 4.0045 4.0045 0 0129 25zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0125 29 4.0045 4.0045 0 0121 25zM19.59 16L17 18.59 18.42 20 22.42 16 18.42 12 17 13.41 19.59 16zM10.41 16L13 13.41 11.58 12 7.58 16 11.58 20 13 18.59 10.41 16z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M4,9H26v7h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H16V24H4ZM4,4H26V7H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BrightnessContrast = /*#__PURE__*/React.forwardRef(function BrightnessContrast(_ref52, ref) {
  var children = _ref52.children,
    _ref52$size = _ref52.size,
    size = _ref52$size === void 0 ? 16 : _ref52$size,
    rest = _objectWithoutProperties(_ref52, _excluded52);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V5H15zM27 15H30V17H27zM15 27H17V30H15zM2 15H5V17H2z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22 5.73H8.219999999999999V8.73H6.22z",
    transform: "rotate(-45 7.227 7.236)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M23.27 6.23H26.27V8.23H23.27z",
    transform: "rotate(-45 24.766 7.232)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M23.77 23.27H25.77V26.27H23.77z",
    transform: "rotate(-45 24.77 24.77)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47 25.13L7.59 23 9 24.42 6.88 26.54 5.47 25.13zM16 8a8 8 0 108 8A8 8 0 0016 8zm0 14a6 6 0 010-12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BringForward = /*#__PURE__*/React.forwardRef(function BringForward(_ref53, ref) {
  var children = _ref53.children,
    _ref53$size = _ref53.size,
    size = _ref53$size === void 0 ? 16 : _ref53$size,
    rest = _objectWithoutProperties(_ref53, _excluded53);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15H10V12a2.0023 2.0023 0 012-2h3v2H12zM15 30H12a2.0023 2.0023 0 01-2-2V25h2v3h3zM18 28H22V30H18zM28 30H25V28h3V25h2v3A2.0023 2.0023 0 0128 30zM10 18H12V22H10zM28 18H30V22H28zM30 15H28V12H25V10h3a2.0023 2.0023 0 012 2zM18 10H22V12H18z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M8,22H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H20a2.0023,2.0023,0,0,1,2,2V8H20V4H4V20H8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BringToFront = /*#__PURE__*/React.forwardRef(function BringToFront(_ref54, ref) {
  var children = _ref54.children,
    _ref54$size = _ref54.size,
    size = _ref54$size === void 0 ? 16 : _ref54$size,
    rest = _objectWithoutProperties(_ref54, _excluded54);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V20a2.0023,2.0023,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM4,20,3.9985,4H20v6H12a2,2,0,0,0-2,2v8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var WatsonHealthBrushFreehand = /*#__PURE__*/React.forwardRef(function WatsonHealthBrushFreehand(_ref55, ref) {
  var children = _ref55.children,
    _ref55$size = _ref55.size,
    size = _ref55$size === void 0 ? 16 : _ref55$size,
    rest = _objectWithoutProperties(_ref55, _excluded55);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8281 3.1719a4.0941 4.0941 0 00-5.6562 0L4.05 22.292A6.9537 6.9537 0 002 27.2412V30H4.7559a6.9523 6.9523 0 004.95-2.05L28.8281 8.8286a3.999 3.999 0 000-5.6567zM10.91 18.26l2.8286 2.8286L11.6172 23.21 8.7886 20.3818zM8.2915 26.5356A4.9665 4.9665 0 014.7559 28H4v-.7588a4.9669 4.9669 0 011.4644-3.5351l1.91-1.91 2.8286 2.8281zM27.4141 7.4141L15.1528 19.6748l-2.8286-2.8286 12.2617-12.26a2.0473 2.0473 0 012.8282 0 1.9995 1.9995 0 010 2.8282zM6.5 15A3.4994 3.4994 0 014.0249 9.026l3.5005-3.5a1.5019 1.5019 0 000-2.121 1.537 1.537 0 00-2.1216 0L3.415 5.3936 2 3.98 3.99 1.9915a3.5849 3.5849 0 014.95 0 3.5039 3.5039 0 010 4.949L5.439 10.44a1.5019 1.5019 0 000 2.121 1.5369 1.5369 0 002.1215 0l4.0249-4.0243L13 9.9507 8.9746 13.975A3.4754 3.4754 0 016.5 15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var WatsonHealthBrushPolygon = /*#__PURE__*/React.forwardRef(function WatsonHealthBrushPolygon(_ref56, ref) {
  var children = _ref56.children,
    _ref56$size = _ref56.size,
    size = _ref56$size === void 0 ? 16 : _ref56$size,
    rest = _objectWithoutProperties(_ref56, _excluded56);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8281 3.1719a4.0941 4.0941 0 00-5.6562 0L4.05 22.292A6.9537 6.9537 0 002 27.2412V30H4.7559a6.9523 6.9523 0 004.95-2.05L28.8281 8.8286a3.999 3.999 0 000-5.6567zM10.91 18.26l2.8286 2.8286L11.6172 23.21 8.7886 20.3818zM8.2915 26.5356A4.9665 4.9665 0 014.7559 28H4v-.7588a4.9669 4.9669 0 011.4644-3.5351l1.91-1.91 2.8286 2.8281zM27.4141 7.4141L15.1528 19.6748l-2.8286-2.8286 12.2617-12.26a2.0473 2.0473 0 012.8282 0 1.9995 1.9995 0 010 2.8282zM14 2a2.9948 2.9948 0 00-2.8157 2H7.8157A2.9925 2.9925 0 104 7.8154v3.3687a3 3 0 102 0V7.8159A2.9959 2.9959 0 007.8157 6h3.3686A2.9947 2.9947 0 1014 2zM5 15a1 1 0 111-1A1.0008 1.0008 0 015 15zM5 6A1 1 0 116 5 1.0008 1.0008 0 015 6zm9 0a1 1 0 111-1A1.0008 1.0008 0 0114 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BuildTool = /*#__PURE__*/React.forwardRef(function BuildTool(_ref57, ref) {
  var children = _ref57.children,
    _ref57$size = _ref57.size,
    size = _ref57$size === void 0 ? 16 : _ref57$size,
    rest = _objectWithoutProperties(_ref57, _excluded57);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M28,14h-1V7c0-1.1-0.9-2-2-2h-6v2h6v7h-1c-1.1,0-2,0.9-2,2v9H9.9c-0.4-1.4-1.5-2.5-2.9-2.9V7h6.2l-2.6,2.6L12,11l5-5l-5-5 l-1.4,1.4L13.2,5H7C5.9,5,5,5.9,5,7v15.1c-1.7,0.4-3,2-3,3.9c0,2.2,1.8,4,4,4c1.9,0,3.4-1.3,3.9-3H22v1c0,1.1,0.9,2,2,2h4 c1.1,0,2-0.9,2-2V16C30,14.9,29.1,14,28,14z M6,28c-1.1,0-2-0.9-2-2s0.9-2,2-2c1.1,0,2,0.9,2,2S7.1,28,6,28z M24,28V16h4v12H24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Building = /*#__PURE__*/React.forwardRef(function Building(_ref58, ref) {
  var children = _ref58.children,
    _ref58$size = _ref58.size,
    size = _ref58$size === void 0 ? 16 : _ref58$size,
    rest = _objectWithoutProperties(_ref58, _excluded58);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BuildingInsights_1 = /*#__PURE__*/React.forwardRef(function BuildingInsights_1(_ref59, ref) {
  var children = _ref59.children,
    _ref59$size = _ref59.size,
    size = _ref59$size === void 0 ? 16 : _ref59$size,
    rest = _objectWithoutProperties(_ref59, _excluded59);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24zM9 12H7a5.0059 5.0059 0 015-5V9A3.0033 3.0033 0 009 12zM4 12H2A10.0114 10.0114 0 0112 2V4A8.0092 8.0092 0 004 12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BuildingInsights_2 = /*#__PURE__*/React.forwardRef(function BuildingInsights_2(_ref60, ref) {
  var children = _ref60.children,
    _ref60$size = _ref60.size,
    size = _ref60$size === void 0 ? 16 : _ref60$size,
    rest = _objectWithoutProperties(_ref60, _excluded60);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24zM5.5 12a3.5 3.5 0 010-7h.627A4.0062 4.0062 0 0110 2h2V4L10 4A2.0023 2.0023 0 008 6V7H5.5a1.5 1.5 0 000 3H12v2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var BuildingInsights_3 = /*#__PURE__*/React.forwardRef(function BuildingInsights_3(_ref61, ref) {
  var children = _ref61.children,
    _ref61$size = _ref61.size,
    size = _ref61$size === void 0 ? 16 : _ref61$size,
    rest = _objectWithoutProperties(_ref61, _excluded61);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24zM2 10H7V12H2zM10 2H12V7H10z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 3.964H7.5V9.035H5.5z",
    transform: "rotate(-45 6.5 6.5)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Bullhorn = /*#__PURE__*/React.forwardRef(function Bullhorn(_ref62, ref) {
  var children = _ref62.children,
    _ref62$size = _ref62.size,
    size = _ref62$size === void 0 ? 16 : _ref62$size,
    rest = _objectWithoutProperties(_ref62, _excluded62);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6V8.17L5.64,11.87a2,2,0,0,0-1.64,2v4.34a2,2,0,0,0,1.64,2L8,20.56V24a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V22.74l6,1.09V26h2V6ZM18,24H10V20.93l8,1.45ZM6,18.17V13.83L26,10.2V21.8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Buoy = /*#__PURE__*/React.forwardRef(function Buoy(_ref63, ref) {
  var children = _ref63.children,
    _ref63$size = _ref63.size,
    size = _ref63$size === void 0 ? 16 : _ref63$size,
    rest = _objectWithoutProperties(_ref63, _excluded63);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M28,22a3.4376,3.4376,0,0,1-3.0513-2.3164,1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,20,22a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,16,19a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,12,22a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,8,19a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,4,22H2v2H4a4.9316,4.9316,0,0,0,4-1.9873,5.5965,5.5965,0,0,0,1,.9912,7,7,0,0,0,14,0,5.5965,5.5965,0,0,0,1-.9912A4.9316,4.9316,0,0,0,28,24h2V22ZM16,28a5.0021,5.0021,0,0,1-4.9075-4.0854A5.2252,5.2252,0,0,0,12,24a4.9316,4.9316,0,0,0,4-1.9873A4.9316,4.9316,0,0,0,20,24a5.2252,5.2252,0,0,0,.9075-.0854A5.0021,5.0021,0,0,1,16,28Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M20.07,7.8345A2.0116,2.0116,0,0,0,18.0771,6H17V2H15V6H13.9175a1.9949,1.9949,0,0,0-1.9859,1.7715L10.2805,19h2.021l.7346-5h5.9212l.7351,5h2.021ZM13.33,12l.5877-4,4.167.0625L18.6633,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Bus = /*#__PURE__*/React.forwardRef(function Bus(_ref64, ref) {
  var children = _ref64.children,
    _ref64$size = _ref64.size,
    size = _ref64$size === void 0 ? 16 : _ref64$size,
    rest = _objectWithoutProperties(_ref64, _excluded64);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M27 11H29V15H27zM3 11H5V15H3zM20 20H22V22H20zM10 20H12V22H10z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M21,4H11A5.0059,5.0059,0,0,0,6,9V23a2.0023,2.0023,0,0,0,2,2v3h2V25H22v3h2V25a2.0027,2.0027,0,0,0,2-2V9A5.0059,5.0059,0,0,0,21,4Zm3,6,.0009,6H8V10ZM11,6H21a2.995,2.995,0,0,1,2.8157,2H8.1843A2.995,2.995,0,0,1,11,6ZM8,23V18H24.0012l.0008,5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ButtonCentered = /*#__PURE__*/React.forwardRef(function ButtonCentered(_ref65, ref) {
  var children = _ref65.children,
    _ref65$size = _ref65.size,
    size = _ref65$size === void 0 ? 16 : _ref65$size,
    rest = _objectWithoutProperties(_ref65, _excluded65);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15H23V17H9z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M28,22H4a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v8A2.0021,2.0021,0,0,1,28,22ZM4,12v8H28V12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ButtonFlushLeft = /*#__PURE__*/React.forwardRef(function ButtonFlushLeft(_ref66, ref) {
  var children = _ref66.children,
    _ref66$size = _ref66.size,
    size = _ref66$size === void 0 ? 16 : _ref66$size,
    rest = _objectWithoutProperties(_ref66, _excluded66);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15H20V17H6z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M28,22H4c-1.103,0-2-0.897-2-2v-8c0-1.103,0.897-2,2-2h24c1.103,0,2,0.897,2,2v8C30,21.103,29.103,22,28,22z M4,12v8h24v-8 H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CabinCare = /*#__PURE__*/React.forwardRef(function CabinCare(_ref67, ref) {
  var children = _ref67.children,
    _ref67$size = _ref67.size,
    size = _ref67$size === void 0 ? 16 : _ref67$size,
    rest = _objectWithoutProperties(_ref67, _excluded67);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3022 2a2.6617 2.6617 0 00-1.9079.8059l-.3931.4053-.397-.4053a2.6613 2.6613 0 00-3.8158 0 2.7992 2.7992 0 000 3.8963L25.0012 11 29.21 6.7022a2.7992 2.7992 0 000-3.8963A2.6613 2.6613 0 0027.3022 2zM23.8218 18H15.083L11.8643 5.9653a4 4 0 00-7.7276 2.07L8.5454 24.5168A2 2 0 0010.4775 26H19v2H4v2H19a2 2 0 002-2V26h3a4.0046 4.0046 0 003.98-4.4A4.1214 4.1214 0 0023.8218 18zM24 24H10.4776L6.0686 7.5181A2 2 0 119.9324 6.4829L13.5466 20H24a2 2 0 010 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CabinCareAlert = /*#__PURE__*/React.forwardRef(function CabinCareAlert(_ref68, ref) {
  var children = _ref68.children,
    _ref68$size = _ref68.size,
    size = _ref68$size === void 0 ? 16 : _ref68$size,
    rest = _objectWithoutProperties(_ref68, _excluded68);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M24 2H26V9H24z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "3",
    height: "3",
    x: "23.5",
    y: "11",
    rx: "1.5"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8218,18H15.083L11.8643,5.9653a4,4,0,0,0-7.7276,2.07L8.5454,24.5168A2,2,0,0,0,10.4775,26H19v2H4v2H19a2,2,0,0,0,2-2V26h3a4.0046,4.0046,0,0,0,3.98-4.4A4.1215,4.1215,0,0,0,23.8218,18ZM24,24H10.4775L6.0686,7.5181A2,2,0,1,1,9.9324,6.4829L13.5466,20H24a2,2,0,0,1,0,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CabinCareAlt = /*#__PURE__*/React.forwardRef(function CabinCareAlt(_ref69, ref) {
  var children = _ref69.children,
    _ref69$size = _ref69.size,
    size = _ref69$size === void 0 ? 16 : _ref69$size,
    rest = _objectWithoutProperties(_ref69, _excluded69);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M30 25V23H20.7676l-.8-3H27V18H19.4348l-2.469-9.2578-1.9316.5156 3.8017 14.2568A2.0037 2.0037 0 0020.77 25H22v3H10V25h6V23H6.7676l-.8-3H13V18H5.4348L2.9658 8.7422l-1.9316.5156L4.8359 23.5146A2.0037 2.0037 0 006.77 25H8v3H2v2H30V28H24V25zM27.303 2a2.6613 2.6613 0 00-1.9079.8059L25 3.2112l-.3951-.4053a2.6612 2.6612 0 00-3.8157 0 2.7991 2.7991 0 000 3.8963L25 11l4.2108-4.2978a2.7991 2.7991 0 000-3.8963A2.6613 2.6613 0 0027.303 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Cad = /*#__PURE__*/React.forwardRef(function Cad(_ref70, ref) {
  var children = _ref70.children,
    _ref70$size = _ref70.size,
    size = _ref70$size === void 0 ? 16 : _ref70$size,
    rest = _objectWithoutProperties(_ref70, _excluded70);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9H14a2 2 0 00-2 2V23h2V18h4v5h2V11A2 2 0 0018 9zm-4 7V11h4v5zM26 23H22V9h4a4 4 0 014 4v6A4 4 0 0126 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H24zM10 23H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4V21h6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Cafe = /*#__PURE__*/React.forwardRef(function Cafe(_ref71, ref) {
  var children = _ref71.children,
    _ref71$size = _ref71.size,
    size = _ref71$size === void 0 ? 16 : _ref71$size,
    rest = _objectWithoutProperties(_ref71, _excluded71);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2zM24.5 11H8a2.002 2.002 0 00-2 2v8a5.0059 5.0059 0 005 5h8a5.0059 5.0059 0 005-5V20h.5a4.5 4.5 0 000-9zM22 21a3.0033 3.0033 0 01-3 3H11a3.0033 3.0033 0 01-3-3V13H22zm2.5-3H24V13h.5a2.5 2.5 0 010 5zM19 9H17V8.854a1.9883 1.9883 0 00-1.1055-1.7886L13.2109 5.7236A3.9788 3.9788 0 0111 2.146V1h2V2.146a1.9892 1.9892 0 001.1055 1.7886l2.6836 1.3418A3.9792 3.9792 0 0119 8.854z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Calculation = /*#__PURE__*/React.forwardRef(function Calculation(_ref72, ref) {
  var children = _ref72.children,
    _ref72$size = _ref72.size,
    size = _ref72$size === void 0 ? 16 : _ref72$size,
    rest = _objectWithoutProperties(_ref72, _excluded72);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8L10 8 10 4 8 4 8 8 4 8 4 10 8 10 8 14 10 14 10 10 14 10 14 8zM4 19H14V21H4zM4 24H14V26H4zM18 8H28V10H18zM24.41 22L28 18.41 26.59 17 23 20.59 19.41 17 18 18.41 21.59 22 18 25.59 19.41 27 23 23.41 26.59 27 28 25.59 24.41 22z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CalculationAlt = /*#__PURE__*/React.forwardRef(function CalculationAlt(_ref73, ref) {
  var children = _ref73.children,
    _ref73$size = _ref73.size,
    size = _ref73$size === void 0 ? 16 : _ref73$size,
    rest = _objectWithoutProperties(_ref73, _excluded73);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M19 13H25V15H19zM13 21L11 21 11 19 9 19 9 21 7 21 7 23 9 23 9 25 11 25 11 23 13 23 13 21zM7 9H13V11H7zM19 17H25V19H19z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2.0023,2.0023,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3ZM15,5V15H5V5ZM5,17H15V27H5ZM17,27V5H27V27Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Calculator = /*#__PURE__*/React.forwardRef(function Calculator(_ref74, ref) {
  var children = _ref74.children,
    _ref74$size = _ref74.size,
    size = _ref74$size === void 0 ? 16 : _ref74$size,
    rest = _objectWithoutProperties(_ref74, _excluded74);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4V28H6V4H26m0-2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M9 23H11V25H9zM21 23H23V25H21zM9 18H11V20H9zM21 18H23V20H21zM9 13H11V15H9zM15 23H17V25H15zM15 18H17V20H15zM15 13H17V15H15zM21 13H23V15H21zM9 7H23V10H9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CalculatorCheck = /*#__PURE__*/React.forwardRef(function CalculatorCheck(_ref75, ref) {
  var children = _ref75.children,
    _ref75$size = _ref75.size,
    size = _ref75$size === void 0 ? 16 : _ref75$size,
    rest = _objectWithoutProperties(_ref75, _excluded75);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26.59L21.41 24 20 25.41 24 29.41 31 22.41 29.59 21 24 26.59zM15 23H17V25H15zM9 23H11V25H9zM21 18H23V20H21zM15 18H17V20H15zM9 18H11V20H9zM21 13H23V15H21zM15 13H17V15H15zM9 13H11V15H9zM9 7H23V10H9z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M17,30H6.0046A2.007,2.007,0,0,1,4,27.9951V3.9961A1.9984,1.9984,0,0,1,5.9961,2H26.0037A1.9985,1.9985,0,0,1,28,3.9961V18H26V4H6V28H17Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Calendar = /*#__PURE__*/React.forwardRef(function Calendar(_ref76, ref) {
  var children = _ref76.children,
    _ref76$size = _ref76.size,
    size = _ref76$size === void 0 ? 16 : _ref76$size,
    rest = _objectWithoutProperties(_ref76, _excluded76);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V6C28,4.9,27.1,4,26,4z M26,26H6V12h20 V26z M26,10H6V6h4v2h2V6h8v2h2V6h4V10z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CalendarAdd = /*#__PURE__*/React.forwardRef(function CalendarAdd(_ref77, ref) {
  var children = _ref77.children,
    _ref77$size = _ref77.size,
    size = _ref77$size === void 0 ? 16 : _ref77$size,
    rest = _objectWithoutProperties(_ref77, _excluded77);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30 22L24 22 24 16 22 16 22 22 16 22 16 24 22 24 22 30 24 30 24 24 30 24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,6c0-1.1-0.9-2-2-2h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h8v-2H6V6h4v2h2V6h8v2h2V6h4v8h2V6z"
  })))), children);
});
if (process.env.NODE_ENV !== "production") {}
var CalendarAddAlt = /*#__PURE__*/React.forwardRef(function CalendarAddAlt(_ref78, ref) {
  var children = _ref78.children,
    _ref78$size = _ref78.size,
    size = _ref78$size === void 0 ? 16 : _ref78$size,
    rest = _objectWithoutProperties(_ref78, _excluded78);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _switch2 || (_switch2 = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26 21L23 21 23 18 21 18 21 21 18 21 18 23 21 23 21 26 23 26 23 23 26 23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,30c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S26.4,30,22,30z M22,16c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S25.3,16,22,16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,6c0-1.1-0.9-2-2-2h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h6v-2H6V6h4v2h2V6h8v2h2V6h4v6h2V6z"
  })))), children);
});
if (process.env.NODE_ENV !== "production") {}
var CalendarHeatMap = /*#__PURE__*/React.forwardRef(function CalendarHeatMap(_ref79, ref) {
  var children = _ref79.children,
    _ref79$size = _ref79.size,
    size = _ref79$size === void 0 ? 16 : _ref79$size,
    rest = _objectWithoutProperties(_ref79, _excluded79);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H22V2H20V4H12V2H10V4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM6,6h4V8h2V6h8V8h2V6h4l0,4H6Zm0,6h5v6H6ZM19,26H13V20h6Zm0-8H13V12h6Zm2,8V20h5l.0012,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CalendarSettings = /*#__PURE__*/React.forwardRef(function CalendarSettings(_ref80, ref) {
  var children = _ref80.children,
    _ref80$size = _ref80.size,
    size = _ref80$size === void 0 ? 16 : _ref80$size,
    rest = _objectWithoutProperties(_ref80, _excluded80);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M30,23V21H27.91a5.9592,5.9592,0,0,0-1.0244-2.4707L28.364,17.05,26.95,15.6362l-1.4788,1.4785A5.9584,5.9584,0,0,0,23,16.09V14H21v2.09a5.9584,5.9584,0,0,0-2.4709,1.0244L17.05,15.6362,15.636,17.05l1.4787,1.479A5.9618,5.9618,0,0,0,16.09,21H14v2h2.09a5.9618,5.9618,0,0,0,1.0244,2.4707L15.636,26.95,17.05,28.3638l1.4788-1.4785A5.9584,5.9584,0,0,0,21,27.91V30h2V27.91a5.9584,5.9584,0,0,0,2.4709-1.0244L26.95,28.3638,28.364,26.95l-1.4787-1.479A5.9592,5.9592,0,0,0,27.91,23Zm-8,3a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,26Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CalendarTools = /*#__PURE__*/React.forwardRef(function CalendarTools(_ref81, ref) {
  var children = _ref81.children,
    _ref81$size = _ref81.size,
    size = _ref81$size === void 0 ? 16 : _ref81$size,
    rest = _objectWithoutProperties(_ref81, _excluded81);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M23.981,24.4333A3.9549,3.9549,0,0,0,26,25a4.0045,4.0045,0,0,0,4-4,3.9427,3.9427,0,0,0-.1492-1.0228l-2.4367,2.4369-.0005-.0005a1.9991,1.9991,0,1,1-2.8272-2.8272l-.0005-.0005,2.4368-2.4368A3.95,3.95,0,0,0,26,17a4.0045,4.0045,0,0,0-4,4,3.9544,3.9544,0,0,0,.5669,2.0191L17,28.586,18.4141,30Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h8V26H6V6h4V8h2V6h8V8h2V6h4v8h2V6A2,2,0,0,0,26,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Calibrate = /*#__PURE__*/React.forwardRef(function Calibrate(_ref82, ref) {
  var children = _ref82.children,
    _ref82$size = _ref82.size,
    size = _ref82$size === void 0 ? 16 : _ref82$size,
    rest = _objectWithoutProperties(_ref82, _excluded82);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M28.83,21.17,25,17.37l.67-.67a1,1,0,0,0,0-1.41l-6-6a1,1,0,0,0-1.41,0h0l-.79.79L10.71,3.29a1,1,0,0,0-1.41,0h0l-4,4-.12.15-4,6a1,1,0,0,0,.12,1.26l3,3a1,1,0,0,0,1.42,0L10,13.41l2.09,2.09-4.8,4.79a1,1,0,0,0,0,1.41l2,2A1,1,0,0,0,10,24a1,1,0,0,0,.52-.15l4.33-2.6,2.44,2.45a1,1,0,0,0,1.41,0h0l.67-.7,3.79,3.83a4,4,0,0,0,5.66-5.66ZM10,10.58l-5,5L3.29,13.87,6.78,8.63,10,5.41l6.09,6.09L13.5,14.08Zm8,11-2.84-2.84-5,3L9.42,21,19,11.41,23.59,16Zm9.42,3.83a2,2,0,0,1-2.83,0h0l-3.8-3.79,2.83-2.83,3.8,3.79a2,2,0,0,1,0,2.83Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Camera = /*#__PURE__*/React.forwardRef(function Camera(_ref83, ref) {
  var children = _ref83.children,
    _ref83$size = _ref83.size,
    size = _ref83$size === void 0 ? 16 : _ref83$size,
    rest = _objectWithoutProperties(_ref83, _excluded83);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M29,26H3a1,1,0,0,1-1-1V8A1,1,0,0,1,3,7H9.46l1.71-2.55A1,1,0,0,1,12,4h8a1,1,0,0,1,.83.45L22.54,7H29a1,1,0,0,1,1,1V25A1,1,0,0,1,29,26ZM4,24H28V9H22a1,1,0,0,1-.83-.45L19.46,6H12.54L10.83,8.55A1,1,0,0,1,10,9H4Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,1,6-6A6,6,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,16,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CameraAction = /*#__PURE__*/React.forwardRef(function CameraAction(_ref84, ref) {
  var children = _ref84.children,
    _ref84$size = _ref84.size,
    size = _ref84$size === void 0 ? 16 : _ref84$size,
    rest = _objectWithoutProperties(_ref84, _excluded84);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M12,23a6,6,0,1,1,6-6A6,6,0,0,1,12,23Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,12,13Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M29,27H3a1,1,0,0,1-1-1V6A1,1,0,0,1,3,5H29a1,1,0,0,1,1,1V26A1,1,0,0,1,29,27ZM4,25H28V7H4Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M19 9H26V11H19z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "17",
    r: "1"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Campsite = /*#__PURE__*/React.forwardRef(function Campsite(_ref85, ref) {
  var children = _ref85.children,
    _ref85$size = _ref85.size,
    size = _ref85$size === void 0 ? 16 : _ref85$size,
    rest = _objectWithoutProperties(_ref85, _excluded85);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5618,26,17.17,8.9277,19.5361,5.04,17.8281,4,16,7.0049,14.17,4l-1.708,1.04,2.3665,3.8877L4.438,26H2v2H30V26ZM16,10.8506,25.2207,26H17V18H15v8H6.7791Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Car = /*#__PURE__*/React.forwardRef(function Car(_ref86, ref) {
  var children = _ref86.children,
    _ref86$size = _ref86.size,
    size = _ref86$size === void 0 ? 16 : _ref86$size,
    rest = _objectWithoutProperties(_ref86, _excluded86);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3379,15.9336l-7.7324-2.7783L18.374,9.0967A2.99,2.99,0,0,0,16.0537,8H8.0576a2.9982,2.9982,0,0,0-2.48,1.3115L2.8662,13.2949A4.9884,4.9884,0,0,0,2,16.1074V24a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V16.875A1,1,0,0,0,29.3379,15.9336ZM9,26a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,23,26Zm5-3H26.8579a3.9806,3.9806,0,0,0-7.7158,0H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V16.1074A2.9977,2.9977,0,0,1,4.52,14.4189l2.711-3.9814A.9992.9992,0,0,1,8.0576,10h7.9961a.9928.9928,0,0,1,.7647.3545l3.3994,4.2685a1.0007,1.0007,0,0,0,.4443.3184L28,17.5781Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CarFront = /*#__PURE__*/React.forwardRef(function CarFront(_ref87, ref) {
  var children = _ref87.children,
    _ref87$size = _ref87.size,
    size = _ref87$size === void 0 ? 16 : _ref87$size,
    rest = _objectWithoutProperties(_ref87, _excluded87);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M13 19H19V21H13z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4409,14,24.1687,9.45A2.009,2.009,0,0,0,22.2456,8H9.7544A2.0089,2.0089,0,0,0,7.8313,9.4507L6.5315,14H4v2H6v7a2.0025,2.0025,0,0,0,2,2v3h2V25H22v3h2V25a2.0025,2.0025,0,0,0,2-2V16h2V14ZM9.7544,10H22.2458l1.4285,5H8.3257ZM24,21v2H8V21h2V19H8V17H24v2H22v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Carbon = /*#__PURE__*/React.forwardRef(function Carbon(_ref88, ref) {
  var children = _ref88.children,
    _ref88$size = _ref88.size,
    size = _ref88$size === void 0 ? 16 : _ref88$size,
    rest = _objectWithoutProperties(_ref88, _excluded88);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5,30.8149a1.0011,1.0011,0,0,1-.4927-.13l-8.5-4.815A1,1,0,0,1,4,25V15a1,1,0,0,1,.5073-.87l8.5-4.815a1.0013,1.0013,0,0,1,.9854,0l8.5,4.815A1,1,0,0,1,23,15V25a1,1,0,0,1-.5073.87l-8.5,4.815A1.0011,1.0011,0,0,1,13.5,30.8149ZM6,24.417l7.5,4.2485L21,24.417V15.583l-7.5-4.2485L6,15.583Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M28,17H26V7.583L18.5,3.3345,10.4927,7.87,9.5073,6.13l8.5-4.815a1.0013,1.0013,0,0,1,.9854,0l8.5,4.815A1,1,0,0,1,28,7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CarbonUiBuilder = /*#__PURE__*/React.forwardRef(function CarbonUiBuilder(_ref89, ref) {
  var children = _ref89.children,
    _ref89$size = _ref89.size,
    size = _ref89$size === void 0 ? 16 : _ref89$size,
    rest = _objectWithoutProperties(_ref89, _excluded89);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28H30V30H24z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "29",
    r: "1"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "29",
    cy: "25",
    r: "1"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24H26V26H20z",
    transform: "rotate(-180 23 25)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20H30V22H24z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "21",
    r: "1"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4927,14.1299l-8.5-4.8149c-.3057-.1729-.6797-.1729-.9854,0L3.5073,14.1299c-.3135,.1777-.5073,.5098-.5073,.8701v10c0,.3604,.1938,.6924,.5073,.8701l8.5,4.8149,.9854-1.7402-7.9927-4.5278V15.583l7.5-4.2485,7.5,4.2485v2.417h2v-3c0-.3604-.1938-.6924-.5073-.8701Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M25,15h2V7c0-.3604-.1938-.6924-.5073-.8701L17.9927,1.3149c-.3057-.1729-.6797-.1729-.9854,0L8.5074,6.1299l.9854,1.7402L17.5,3.3345l7.5,4.2485v7.417Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CarbonAccounting = /*#__PURE__*/React.forwardRef(function CarbonAccounting(_ref90, ref) {
  var children = _ref90.children,
    _ref90$size = _ref90.size,
    size = _ref90$size === void 0 ? 16 : _ref90$size,
    rest = _objectWithoutProperties(_ref90, _excluded90);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M29 26H23V22a2.002 2.002 0 012-2h2V18H23V16h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H25v2h4zM19 22H15a2.0023 2.0023 0 01-2-2V10a2.002 2.002 0 012-2h4a2.002 2.002 0 012 2V20A2.0023 2.0023 0 0119 22zM15 10V20h4V10zM11 22H5a2.0023 2.0023 0 01-2-2V10A2.002 2.002 0 015 8h6v2H5V20h6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CarbonForIbmDotcom = /*#__PURE__*/React.forwardRef(function CarbonForIbmDotcom(_ref91, ref) {
  var children = _ref91.children,
    _ref91$size = _ref91.size,
    size = _ref91$size === void 0 ? 16 : _ref91$size,
    rest = _objectWithoutProperties(_ref91, _excluded91);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M29.509,17.689l-6-3.55C23.352,14.046,23.176,14,23,14s-0.352,0.046-0.509,0.14l-6,3.55C16.187,17.869,16,18.196,16,18.55 v6.9c0,0.354,0.187,0.681,0.491,0.86l6,3.55C22.648,29.954,22.824,30,23,30s0.352-0.046,0.509-0.14l6-3.55 C29.813,26.131,30,25.804,30,25.45v-6.9C30,18.196,29.813,17.869,29.509,17.689z M28,24.88l-5,2.958l-5-2.958v-5.76l5-2.958l5,2.958 V24.88z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "6",
    r: "1"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "6",
    r: "1"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4C2.897,2,2,2.897,2,4v20c0,1.103,0.897,2,2,2h9v-2H4V10h24v4h2V4C30,2.897,29.103,2,28,2z M4,8V4h24v4H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CarbonForIbmProduct = /*#__PURE__*/React.forwardRef(function CarbonForIbmProduct(_ref92, ref) {
  var children = _ref92.children,
    _ref92$size = _ref92.size,
    size = _ref92$size === void 0 ? 16 : _ref92$size,
    rest = _objectWithoutProperties(_ref92, _excluded92);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M22.509,12.689l-6-3.55C16.352,9.046,16.176,9,16,9s-0.352,0.046-0.509,0.14l-6,3.55C9.187,12.869,9,13.196,9,13.55v6.9 c0,0.354,0.187,0.681,0.491,0.86l6,3.55C15.648,24.954,15.824,25,16,25s0.352-0.046,0.509-0.14l6-3.55 C22.813,21.131,23,20.804,23,20.45v-6.9C23,13.196,22.813,12.869,22.509,12.689z M21,19.88l-5,2.958l-5-2.958v-5.76l5-2.958l5,2.958 V19.88z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20.184V11.07l6.2-3.664-1.017-1.722L4.491 9.639C4.187 9.819 4 10.146 4 10.5v9.684C2.839 20.598 2 21.698 2 23c0 1.654 1.346 3 3 3s3-1.346 3-3C8 21.698 7.161 20.598 6 20.184zM5 24c-.551 0-1-.448-1-1s.449-1 1-1 1 .448 1 1S5.551 24 5 24zM27 20c-1.654 0-3 1.346-3 3 0 .353.072.687.185 1.002L16 28.838l-6.404-3.784-1.017 1.722 6.912 4.084C15.648 30.954 15.824 31 16 31s.352-.046.509-.139l8.96-5.295C25.919 25.835 26.439 26 27 26c1.654 0 3-1.346 3-3S28.654 20 27 20zM27 24c-.551 0-1-.448-1-1s.449-1 1-1 1 .448 1 1S27.551 24 27 24zM16 7c.731 0 1.392-.273 1.913-.708L26 11.071V18h2v-7.5c0-.354-.187-.681-.491-.861l-8.567-5.062C18.978 4.39 19 4.198 19 4c0-1.654-1.346-3-3-3s-3 1.346-3 3S14.346 7 16 7zM16 3c.551 0 1 .448 1 1s-.449 1-1 1-1-.448-1-1S15.449 3 16 3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CaretDown = /*#__PURE__*/React.forwardRef(function CaretDown(_ref93, ref) {
  var children = _ref93.children,
    _ref93$size = _ref93.size,
    size = _ref93$size === void 0 ? 16 : _ref93$size,
    rest = _objectWithoutProperties(_ref93, _excluded93);
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 8 4",
      fill: "currentColor"
    }, rest), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
      d: "M8 0L4 4 0 0z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12L16 22 8 12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CaretLeft = /*#__PURE__*/React.forwardRef(function CaretLeft(_ref94, ref) {
  var children = _ref94.children,
    _ref94$size = _ref94.size,
    size = _ref94$size === void 0 ? 16 : _ref94$size,
    rest = _objectWithoutProperties(_ref94, _excluded94);
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 5 8",
      fill: "currentColor"
    }, rest), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
      d: "M5 8L0 4 5 0z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24L10 16 20 8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CaretRight = /*#__PURE__*/React.forwardRef(function CaretRight(_ref95, ref) {
  var children = _ref95.children,
    _ref95$size = _ref95.size,
    size = _ref95$size === void 0 ? 16 : _ref95$size,
    rest = _objectWithoutProperties(_ref95, _excluded95);
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 5 8",
      fill: "currentColor"
    }, rest), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
      d: "M0 0L5 4 0 8z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8L22 16 12 24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CaretSort = /*#__PURE__*/React.forwardRef(function CaretSort(_ref96, ref) {
  var children = _ref96.children,
    _ref96$size = _ref96.size,
    size = _ref96$size === void 0 ? 16 : _ref96$size,
    rest = _objectWithoutProperties(_ref96, _excluded96);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24L16 32 8 24zM8 8L16 0 24 8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CaretSortDown = /*#__PURE__*/React.forwardRef(function CaretSortDown(_ref97, ref) {
  var children = _ref97.children,
    _ref97$size = _ref97.size,
    size = _ref97$size === void 0 ? 16 : _ref97$size,
    rest = _objectWithoutProperties(_ref97, _excluded97);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24L16 32 8 24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CaretSortUp = /*#__PURE__*/React.forwardRef(function CaretSortUp(_ref98, ref) {
  var children = _ref98.children,
    _ref98$size = _ref98.size,
    size = _ref98$size === void 0 ? 16 : _ref98$size,
    rest = _objectWithoutProperties(_ref98, _excluded98);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8L16 0 24 8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CaretUp = /*#__PURE__*/React.forwardRef(function CaretUp(_ref99, ref) {
  var children = _ref99.children,
    _ref99$size = _ref99.size,
    size = _ref99$size === void 0 ? 16 : _ref99$size,
    rest = _objectWithoutProperties(_ref99, _excluded99);
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 8 4",
      fill: "currentColor"
    }, rest), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
      d: "M0 4L4 0 8 4z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20L16 10 24 20z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CarouselHorizontal = /*#__PURE__*/React.forwardRef(function CarouselHorizontal(_ref100, ref) {
  var children = _ref100.children,
    _ref100$size = _ref100.size,
    size = _ref100$size === void 0 ? 16 : _ref100$size,
    rest = _objectWithoutProperties(_ref100, _excluded100);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26H10a2 2 0 01-2-2V8a2 2 0 012-2H22a2 2 0 012 2V24A2 2 0 0122 26zM10 8V24H22V8zM4 24H0V22H4V10H0V8H4a2 2 0 012 2V22A2 2 0 014 24zM32 24H28a2 2 0 01-2-2V10a2 2 0 012-2h4v2H28V22h4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CarouselVertical = /*#__PURE__*/React.forwardRef(function CarouselVertical(_ref101, ref) {
  var children = _ref101.children,
    _ref101$size = _ref101.size,
    size = _ref101$size === void 0 ? 16 : _ref101$size,
    rest = _objectWithoutProperties(_ref101, _excluded101);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M26 10V22a2 2 0 01-2 2H8a2 2 0 01-2-2V10A2 2 0 018 8H24A2 2 0 0126 10zM8 22H24V10H8zM24 28v4H22V28H10v4H8V28a2 2 0 012-2H22A2 2 0 0124 28zM24 0V4a2 2 0 01-2 2H10A2 2 0 018 4V0h2V4H22V0z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Catalog = /*#__PURE__*/React.forwardRef(function Catalog(_ref102, ref) {
  var children = _ref102.children,
    _ref102$size = _ref102.size,
    size = _ref102$size === void 0 ? 16 : _ref102$size,
    rest = _objectWithoutProperties(_ref102, _excluded102);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2H8A2,2,0,0,0,6,4V8H4v2H6v5H4v2H6v5H4v2H6v4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H8V24h2V22H8V17h2V15H8V10h2V8H8V4H26Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8H22V10H14zM14 15H22V17H14zM14 22H22V24H14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CatalogPublish = /*#__PURE__*/React.forwardRef(function CatalogPublish(_ref103, ref) {
  var children = _ref103.children,
    _ref103$size = _ref103.size,
    size = _ref103$size === void 0 ? 16 : _ref103$size,
    rest = _objectWithoutProperties(_ref103, _excluded103);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20L21.4 21.4 18.8 24 28 24 28 26 18.8 26 21.4 28.6 20 30 15 25zM14 15H22V17H14zM14 8H22V10H14z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M13,28H8v-4h2v-2H8v-5h2v-2H8v-5h2V8H8V4h18v16h2V4c0-1.1-0.9-2-2-2H8C6.9,2,6,2.9,6,4v4H4v2h2v5H4v2h2v5H4v2h2v4 c0,1.1,0.9,2,2,2h5V28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Categories = /*#__PURE__*/React.forwardRef(function Categories(_ref104, ref) {
  var children = _ref104.children,
    _ref104$size = _ref104.size,
    size = _ref104$size === void 0 ? 16 : _ref104$size,
    rest = _objectWithoutProperties(_ref104, _excluded104);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76 6l.45.89L7.76 8H12v5H4V6H6.76m.62-2H3A1 1 0 002 5v9a1 1 0 001 1H13a1 1 0 001-1V7a1 1 0 00-1-1H9L8.28 4.55A1 1 0 007.38 4zM22.76 6l.45.89L23.76 8H28v5H20V6h2.76m.62-2H19a1 1 0 00-1 1v9a1 1 0 001 1H29a1 1 0 001-1V7a1 1 0 00-1-1H25l-.72-1.45a1 1 0 00-.9-.55zM6.76 19l.45.89L7.76 21H12v5H4V19H6.76m.62-2H3a1 1 0 00-1 1v9a1 1 0 001 1H13a1 1 0 001-1V20a1 1 0 00-1-1H9l-.72-1.45a1 1 0 00-.9-.55zM22.76 19l.45.89L23.76 21H28v5H20V19h2.76m.62-2H19a1 1 0 00-1 1v9a1 1 0 001 1H29a1 1 0 001-1V20a1 1 0 00-1-1H25l-.72-1.45a1 1 0 00-.9-.55z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Category = /*#__PURE__*/React.forwardRef(function Category(_ref105, ref) {
  var children = _ref105.children,
    _ref105$size = _ref105.size,
    size = _ref105$size === void 0 ? 16 : _ref105$size,
    rest = _objectWithoutProperties(_ref105, _excluded105);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22.1414V18a2,2,0,0,0-2-2H17V12h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H13a2.002,2.002,0,0,0-2,2v6a2.002,2.002,0,0,0,2,2h2v4H7a2,2,0,0,0-2,2v4.1421a4,4,0,1,0,2,0V18h8v4.142a4,4,0,1,0,2,0V18h8v4.1414a4,4,0,1,0,2,0ZM13,4h6l.001,6H13ZM8,26a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,26Zm10,0a2,2,0,1,1-2-2A2.0027,2.0027,0,0,1,18,26Zm8,2a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CategoryAdd = /*#__PURE__*/React.forwardRef(function CategoryAdd(_ref106, ref) {
  var children = _ref106.children,
    _ref106$size = _ref106.size,
    size = _ref106$size === void 0 ? 16 : _ref106$size,
    rest = _objectWithoutProperties(_ref106, _excluded106);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6L13.59 7.41 17.17 11 13.59 14.59 15 16 20 11 15 6z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M28,24H17V20h6a2.0027,2.0027,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H9A2.002,2.002,0,0,0,7,4V18a2.0023,2.0023,0,0,0,2,2h6v4H4a2,2,0,0,0-2,2v4H4V26H15v4h2V26H28v4h2V26A2,2,0,0,0,28,24ZM9,4H23l.002,14H9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CategoryAnd = /*#__PURE__*/React.forwardRef(function CategoryAnd(_ref107, ref) {
  var children = _ref107.children,
    _ref107$size = _ref107.size,
    size = _ref107$size === void 0 ? 16 : _ref107$size,
    rest = _objectWithoutProperties(_ref107, _excluded107);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M4 30V26H15v4h2V26H28v4h2V26a2 2 0 00-2-2H17V19H15v5H4a2 2 0 00-2 2v4zM20.6953 13.9858A10.08 10.08 0 0021.9463 10H23V8H20V9a9.2634 9.2634 0 01-.6641 3.2705L16.6511 8.8816a5.1261 5.1261 0 002.1436-2.3694A3.2522 3.2522 0 0018.6062 3.81a3.38 3.38 0 00-2.2391-1.7056 3.4688 3.4688 0 00-4.2223 2.1186c-.5044 1.5518.4406 3.1158 1.2612 4.1077A4.7255 4.7255 0 0011.06 13.1587 4.4526 4.4526 0 0015.4268 17h.0058a5.7844 5.7844 0 003.9717-1.4233L20.532 17h2.5519zM14.047 4.8413A1.3224 1.3224 0 0115.4141 4a2.41 2.41 0 01.5214.0581 1.4018 1.4018 0 01.9111.7022 1.2493 1.2493 0 01.0791 1.042A3.6871 3.6871 0 0115.2441 7.395C14.5831 6.6816 13.8087 5.5732 14.047 4.8413zM15.4316 15h-.0039a2.4432 2.4432 0 01-2.3916-2.1509 2.8261 2.8261 0 011.81-3.0249l3.3115 4.1787A3.8853 3.8853 0 0115.4316 15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CategoryNew = /*#__PURE__*/React.forwardRef(function CategoryNew(_ref108, ref) {
  var children = _ref108.children,
    _ref108$size = _ref108.size,
    size = _ref108$size === void 0 ? 16 : _ref108$size,
    rest = _objectWithoutProperties(_ref108, _excluded108);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10L17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M28,24H17V20h6a2.0027,2.0027,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H9A2.002,2.002,0,0,0,7,4V18a2.0023,2.0023,0,0,0,2,2h6v4H4a2,2,0,0,0-2,2v4H4V26H15v4h2V26H28v4h2V26A2,2,0,0,0,28,24ZM9,4H23l.002,14H9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CategoryNewEach = /*#__PURE__*/React.forwardRef(function CategoryNewEach(_ref109, ref) {
  var children = _ref109.children,
    _ref109$size = _ref109.size,
    size = _ref109$size === void 0 ? 16 : _ref109$size,
    rest = _objectWithoutProperties(_ref109, _excluded109);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M29 10H24v2h5v6H22v2h3v2.142a4 4 0 102 0V20h2a2.0027 2.0027 0 002-2V12A2.0023 2.0023 0 0029 10zM28 26a2 2 0 11-2-2A2.0027 2.0027 0 0128 26zM19 6H14V8h5v6H12v2h3v6.142a4 4 0 102 0V16h2a2.0023 2.0023 0 002-2V8A2.0023 2.0023 0 0019 6zM18 26a2 2 0 11-2-2A2.0027 2.0027 0 0118 26zM9 2H3A2.002 2.002 0 001 4v6a2.002 2.002 0 002 2H5V22.142a4 4 0 102 0V12H9a2.002 2.002 0 002-2V4A2.002 2.002 0 009 2zM8 26a2 2 0 11-2-2A2.0023 2.0023 0 018 26zM3 10V4H9l.0015 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Caution = /*#__PURE__*/React.forwardRef(function Caution(_ref110, ref) {
  var children = _ref110.children,
    _ref110$size = _ref110.size,
    size = _ref110$size === void 0 ? 16 : _ref110$size,
    rest = _objectWithoutProperties(_ref110, _excluded110);
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
      d: "M12.3154,12H3.6846L8,4.0884,12.3154,12M14,13,8,2,2,13Z"
    })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
      d: "M12.315 12L3.685 12 8 4.088 12.315 12z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, rest), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3154,12H3.6846L8,4.0884,12.3154,12M14,13,8,2,2,13Z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M12.315 12L3.685 12 8 4.088 12.315 12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CautionInverted = /*#__PURE__*/React.forwardRef(function CautionInverted(_ref111, ref) {
  var children = _ref111.children,
    _ref111$size = _ref111.size,
    size = _ref111$size === void 0 ? 16 : _ref111$size,
    rest = _objectWithoutProperties(_ref111, _excluded111);
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
      d: "M8 14L2 3 14 3 8 14z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, rest), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14L2 3 14 3 8 14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var QCcX = /*#__PURE__*/React.forwardRef(function QCcX(_ref112, ref) {
  var children = _ref112.children,
    _ref112$size = _ref112.size,
    size = _ref112$size === void 0 ? 16 : _ref112$size,
    rest = _objectWithoutProperties(_ref112, _excluded112);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M10 23H5a2 2 0 01-2-2V15a2 2 0 012-2h5v2H5v6h5zM19 23H14a2 2 0 01-2-2V15a2 2 0 012-2h5v2H14v6h5zM29 9L27 9 25 15 23 9 21 9 23.75 16 21 23 23 23 25 17 27 23 29 23 26.25 16 29 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var WatsonHealthCdArchive = /*#__PURE__*/React.forwardRef(function WatsonHealthCdArchive(_ref113, ref) {
  var children = _ref113.children,
    _ref113$size = _ref113.size,
    size = _ref113$size === void 0 ? 16 : _ref113$size,
    rest = _objectWithoutProperties(_ref113, _excluded113);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28A12,12,0,1,1,28,16,12,12,0,0,1,16,28ZM16,6A10,10,0,1,0,26,16,10,10,0,0,0,16,6Z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,1,6-6A6,6,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,16,12Z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var WatsonHealthCdCreateArchive = /*#__PURE__*/React.forwardRef(function WatsonHealthCdCreateArchive(_ref114, ref) {
  var children = _ref114.children,
    _ref114$size = _ref114.size,
    size = _ref114$size === void 0 ? 16 : _ref114$size,
    rest = _objectWithoutProperties(_ref114, _excluded114);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a6,6,0,1,1,6-6A6,6,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,14,10Z"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "14",
    r: "2"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M17,23.54A10,10,0,1,1,24,14c0,.34,0,.67-.05,1h2c0-.33.05-.66.05-1A12,12,0,1,0,14,26a12.33,12.33,0,0,0,3-.39Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M25,30l-2.14-1A5,5,0,0,1,20,24.47V18H30v6.47A5,5,0,0,1,27.14,29ZM22,20v4.47a3,3,0,0,0,1.72,2.71l1.28.61,1.28-.61A3,3,0,0,0,28,24.47V20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var WatsonHealthCdCreateExchange = /*#__PURE__*/React.forwardRef(function WatsonHealthCdCreateExchange(_ref115, ref) {
  var children = _ref115.children,
    _ref115$size = _ref115.size,
    size = _ref115$size === void 0 ? 16 : _ref115$size,
    rest = _objectWithoutProperties(_ref115, _excluded115);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "14",
    r: "2"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M14,2a12,12,0,0,0,0,24V24A10,10,0,1,1,24,14,8.27,8.27,0,0,1,24,15h2c0-.33.05-.66.05-1A12,12,0,0,0,14,2Z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M17 24L26.17 24 23.58 26.59 25 28 30 23 25 18 23.58 19.42 26.17 22 17 22 17 24zM14 20a6 6 0 116-6A6 6 0 0114 20zm0-10a4 4 0 104 4A4 4 0 0014 10z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Cda = /*#__PURE__*/React.forwardRef(function Cda(_ref116, ref) {
  var children = _ref116.children,
    _ref116$size = _ref116.size,
    size = _ref116$size === void 0 ? 16 : _ref116$size,
    rest = _objectWithoutProperties(_ref116, _excluded116);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9H24a2.002 2.002 0 00-2 2V23h2V18h4v5h2V11A2.0023 2.0023 0 0028 9zm-4 7V11h4v5zM16 23H12V9h4a4.0042 4.0042 0 014 4v6A4.0039 4.0039 0 0116 23zm-2-2h2a2.0027 2.0027 0 002-2V13a2.0023 2.0023 0 00-2-2H14zM10 23H4a2.0023 2.0023 0 01-2-2V11A2.002 2.002 0 014 9h6v2H4V21h6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CellTower = /*#__PURE__*/React.forwardRef(function CellTower(_ref117, ref) {
  var children = _ref117.children,
    _ref117$size = _ref117.size,
    size = _ref117$size === void 0 ? 16 : _ref117$size,
    rest = _objectWithoutProperties(_ref117, _excluded117);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11L25 16 17 16 17 11 15 11 15 16 7 16 7 11 5 11 5 23 7 23 7 18 10 18 10 30 12 30 12 18 15 18 15 23 17 23 17 18 20 18 20 30 22 30 22 18 25 18 25 23 27 23 27 11zM16 6c-1.7 0-3.2.7-4.2 1.8l1.4 1.4C13.9 8.4 14.9 8 16 8s2.1.4 2.8 1.2l1.4-1.4C19.2 6.7 17.7 6 16 6z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9,4.9l1.4,1.4C11.8,4.9,13.8,4,16,4s4.2,0.9,5.7,2.3l1.4-1.4C21.3,3.1,18.8,2,16,2S10.7,3.1,8.9,4.9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CenterCircle = /*#__PURE__*/React.forwardRef(function CenterCircle(_ref118, ref) {
  var children = _ref118.children,
    _ref118$size = _ref118.size,
    size = _ref118$size === void 0 ? 16 : _ref118$size,
    rest = _objectWithoutProperties(_ref118, _excluded118);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15H27.9492A12.0071,12.0071,0,0,0,17,4.0508V2H15V4.0508A12.0071,12.0071,0,0,0,4.0508,15H2v2H4.0508A12.0071,12.0071,0,0,0,15,27.9492V30h2V27.9492A12.0071,12.0071,0,0,0,27.9492,17H30ZM17,25.9492V22H15v3.9492A10.0166,10.0166,0,0,1,6.0508,17H10V15H6.0508A10.0166,10.0166,0,0,1,15,6.0508V10h2V6.0508A10.0166,10.0166,0,0,1,25.9492,15H22v2h3.9492A10.0166,10.0166,0,0,1,17,25.9492Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CenterSquare = /*#__PURE__*/React.forwardRef(function CenterSquare(_ref119, ref) {
  var children = _ref119.children,
    _ref119$size = _ref119.size,
    size = _ref119$size === void 0 ? 16 : _ref119$size,
    rest = _objectWithoutProperties(_ref119, _excluded119);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12L4 12 4 4 12 4 12 6 6 6 6 12zM28 12L26 12 26 6 20 6 20 4 28 4 28 12zM12 28L4 28 4 20 6 20 6 26 12 26 12 28zM28 28L20 28 20 26 26 26 26 20 28 20 28 28zM15 10H17V14H15zM10 15H14V17H10zM18 15H22V17H18zM15 18H17V22H15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CenterToFit = /*#__PURE__*/React.forwardRef(function CenterToFit(_ref120, ref) {
  var children = _ref120.children,
    _ref120$size = _ref120.size,
    size = _ref120$size === void 0 ? 16 : _ref120$size,
    rest = _objectWithoutProperties(_ref120, _excluded120);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2L2 2 2 8 4 8 4 4 8 4 8 2zM24 2L30 2 30 8 28 8 28 4 24 4 24 2zM8 30L2 30 2 24 4 24 4 28 8 28 8 30zM24 30L30 30 30 24 28 24 28 28 24 28 24 30zM24 24H8a2.0023 2.0023 0 01-2-2V10A2.0023 2.0023 0 018 8H24a2.0023 2.0023 0 012 2V22A2.0023 2.0023 0 0124 24zM8 10V22H24V10z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Certificate = /*#__PURE__*/React.forwardRef(function Certificate(_ref121, ref) {
  var children = _ref121.children,
    _ref121$size = _ref121.size,
    size = _ref121$size === void 0 ? 16 : _ref121$size,
    rest = _objectWithoutProperties(_ref121, _excluded121);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17L25.912 20.703 30 21.297 27 24 27.771 28 24 25.75 20.229 28 21 24 18 21.297 22.2 20.703 24 17zM6 16H12V18H6zM6 12H16V14H6zM6 8H16V10H6z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M16,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CertificateCheck = /*#__PURE__*/React.forwardRef(function CertificateCheck(_ref122, ref) {
  var children = _ref122.children,
    _ref122$size = _ref122.size,
    size = _ref122$size === void 0 ? 16 : _ref122$size,
    rest = _objectWithoutProperties(_ref122, _excluded122);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16H12V18H6zM6 12H16V14H6zM6 8H16V10H6z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M14,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M22 25.59L19.41 23 18 24.41 22 28.41 30 20.41 28.59 19 22 25.59z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ChangeCatalog = /*#__PURE__*/React.forwardRef(function ChangeCatalog(_ref123, ref) {
  var children = _ref123.children,
    _ref123$size = _ref123.size,
    size = _ref123$size === void 0 ? 16 : _ref123$size,
    rest = _objectWithoutProperties(_ref123, _excluded123);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24v2h2.4592A5.94 5.94 0 0122 28a6.0066 6.0066 0 01-6-6H14a7.9841 7.9841 0 0014 5.2651V30h2V24zM22 14a8.04 8.04 0 00-6 2.7349V14H14v6h6V18H17.5408A5.94 5.94 0 0122 16a6.0066 6.0066 0 016 6h2A8.0092 8.0092 0 0022 14z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M12,28H6V24H8V22H6V17H8V15H6V10H8V8H6V4H24v8h2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4V8H2v2H4v5H2v2H4v5H2v2H4v4a2,2,0,0,0,2,2h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CharacterDecimal = /*#__PURE__*/React.forwardRef(function CharacterDecimal(_ref124, ref) {
  var children = _ref124.children,
    _ref124$size = _ref124.size,
    size = _ref124$size === void 0 ? 16 : _ref124$size,
    rest = _objectWithoutProperties(_ref124, _excluded124);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15H23V17H21z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M24 23H20a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h4a2.0023 2.0023 0 012 2V21A2.0027 2.0027 0 0124 23zM20 11h0V21h4V11zM11 15H13V17H11z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23H10a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h4a2.0023 2.0023 0 012 2V21A2.0027 2.0027 0 0114 23zM10 11h0V21h4V11zM4 21H6V23H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CharacterFraction = /*#__PURE__*/React.forwardRef(function CharacterFraction(_ref125, ref) {
  var children = _ref125.children,
    _ref125$size = _ref125.size,
    size = _ref125$size === void 0 ? 16 : _ref125$size,
    rest = _objectWithoutProperties(_ref125, _excluded125);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H20V24a2.002,2.002,0,0,1,2-2h4V18H20V16h6a2.0023,2.0023,0,0,1,2,2v4a2.0023,2.0023,0,0,1-2,2H22v4h6Z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M4.479 15.5H26.521V17.5H4.479z",
    transform: "rotate(-45 15.5 16.5)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15.5L4.5 14.5 7.5 14.5 7.5 3.5 4.5 3.5 4.5 2.5 8.5 2.5 8.5 14.5 11.5 14.5 11.5 15.5 4.5 15.5z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M8,3V15H8V3M9,2H4V4H7V14H4v2h8V14H9V2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
export { Basketball, BastionHost, Bat, BatchJob, BatchJobStep, BatteryCharging, BatteryEmpty, BatteryFull, BatteryHalf, BatteryLow, BatteryQuarter, Bee, BeeBat, Beta, Bicycle, Binoculars, BlockStorage, BlockStorageAlt, Blockchain, Blog, Bluetooth, BluetoothOff, Book, Bookmark, BookmarkAdd, BookmarkFilled, Boolean, Boot, BootVolume, BootVolumeAlt, BorderBottom, BorderFull, BorderLeft, BorderNone, BorderRight, BorderTop, Bot, BottlesContainer, Bottles_01, Bottles_01Dash, Bottles_02, Bottles_02Dash, Box, BoxExtraLarge, BoxLarge, BoxMedium, BoxPlot, BoxSmall, Branch, BreakingChange, BrightnessContrast, BringForward, BringToFront, BuildTool, Building, BuildingInsights_1, BuildingInsights_2, BuildingInsights_3, Bullhorn, Buoy, Bus, ButtonCentered, ButtonFlushLeft, CabinCare, CabinCareAlert, CabinCareAlt, Cad, Cafe, Calculation, CalculationAlt, Calculator, CalculatorCheck, Calendar, CalendarAdd, CalendarAddAlt, CalendarHeatMap, CalendarSettings, CalendarTools, Calibrate, Camera, CameraAction, Campsite, Car, CarFront, Carbon, CarbonAccounting, CarbonForIbmDotcom, CarbonForIbmProduct, CarbonUiBuilder, CaretDown, CaretLeft, CaretRight, CaretSort, CaretSortDown, CaretSortUp, CaretUp, CarouselHorizontal, CarouselVertical, Catalog, CatalogPublish, Categories, Category, CategoryAdd, CategoryAnd, CategoryNew, CategoryNewEach, Caution, CautionInverted, Cda, CellTower, CenterCircle, CenterSquare, CenterToFit, Certificate, CertificateCheck, ChangeCatalog, CharacterDecimal, CharacterFraction, QBlochSphere, QCcX, WatsonHealthBrushFreehand, WatsonHealthBrushPolygon, WatsonHealthCdArchive, WatsonHealthCdCreateArchive, WatsonHealthCdCreateExchange };